/* eslint-disable max-len */
module.exports = {
  "sys": {
    "type": "Array"
  },
  "total": 100,
  "skip": 0,
  "limit": 100,
  "items": [
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2PR8BEKiNBjJzwxZT6dTOs",
        "type": "Entry",
        "createdAt": "2019-09-19T11:45:51.194Z",
        "updatedAt": "2019-09-20T12:44:05.108Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 66,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/john.edmonds.jpg",
        "name": "John Edmonds",
        "job": "Photographer, artist",
        "sector": "Arts",
        "location": "New York City",
        "age": 31,
        "bio": "His work photographically explores [the way young black men in America are perceived](http://www.thefader.com/2016/07/21/john-edmonds-photographer-interview) by the world and how the world&#39;s perceptions can morph into mirrored self-perceptions. Edmonds&#39; &quot;[Du-Rags](https://www.newyorker.com/culture/photo-booth/john-edmondss-luminous-images-of-men-in-do-rags)&quot; and &quot;[Hoods](https://www.thefader.com/2016/07/21/john-edmonds-photographer-interview)&quot; series exemplify his talent for taking the everyday and turning them into a point of study and complexity. Last year, Time Magazine named &quot;[Higher](https://becapricious.com/publications/higher-by-john-edmonds/),&quot; his debut photobook spanning the first decade of his practice, one of the top 25 in the category. This year, the Yale alum and faculty member, who won [Brooklyn Museum&#39;s first-ever UOVO Prize for Emerging Artists](http://www.artnews.com/2019/07/09/john-edmonds-uovo-prize-brooklyn-museum/), was invited to showcase his photo, &quot;The Villain&quot; in [the 2019 Whitney Biennial](https://www.nycgo.com/articles/whitney-biennial-2019), a premier exhibition of exciting up-and-comers in the expansive art world. Edmonds also appeared on the 2019 [Forbes 30 under 30 list](https://www.forbes.com/profile/john-edmonds/?list=30under30-art-style#5ffb6100346e), an early accolade even as his star continues to rise.",
        "website": "https://johnedmonds.studio/",
        "claimToFame": "Edmonds is articulating messages about black men through his photography that have earned him a showcase at the Whitney Biennial in New York City.",
        "influence": 153.7,
        "reach": 8.32,
        "substance": 7.3,
        "instagramUrl": "https://www.instagram.com/johncedmonds/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1uGlozkAhDmBBQuk5SVMUY",
        "type": "Entry",
        "createdAt": "2019-09-18T23:41:36.876Z",
        "updatedAt": "2019-09-24T23:07:35.110Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 89,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568650817/alexandra.bell_retouch_htp1xc.jpg",
        "name": "Alexandra Bell",
        "job": "Multimedia artist",
        "sector": "Arts",
        "twitterAccount": "yesitsalex___",
        "location": "New York City",
        "age": 36,
        "bio": "Bell is not [the inventor of counternarratives](https://thescene.com/watch/thenewyorker/rewriting-racist-headlines?fbclid=IwAR15un7uaRSJRy20fGHsEzx20rwUOc2WMs1F0I5UTfbyqytJwU1989JMhqc) but, in a way, she kind of is. The public-art displays she creates in a series called \"Counternarratives\" are a powerful, if not confrontational statement about [the media&#39;s accountability for its narratives](https://www.newyorker.com/culture/culture-desk/the-radical-edits-of-alexandra-bell)—about race, about sexual orientation, about immigration, about who matters and how their stories are presented. She drills down on articles, mainly from the New York Times, and [prints magnified versions to plaster on walls around the city](http://www.alexandrabell.com/public-work) and, most recently, art galleries. It&#39;s a creative labor of love and this year, her exhibition &quot;No Humans Allowed: After Sylvia Wynter&quot; dissected the NY Daily News story on the Exonerated Five and the slanted reporting in it that incited a media frenzy as the case was unfolding in 1989. Bell&#39;s collection was featured at this year&#39;s prestigious [Whitney Biennial](https://whitney.org/exhibitions/2019-Biennial?section=6#exhibition-artworks) in New York City.\n\n",
        "website": "http://www.alexandrabell.com/",
        "claimToFame": "Bell revises newspaper articles about black people to read more equitably. This year, her work was featured in New York City&#39;s Whitney Biennial.",
        "influence": 135.1,
        "reach": 8.53,
        "substance": 6.8,
        "instagramUrl": "https://www.instagram.com/yesitsalex/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6yaRfaNEzphHYfsiFjEZG9",
        "type": "Entry",
        "createdAt": "2019-09-18T00:26:00.519Z",
        "updatedAt": "2019-09-20T19:12:36.254Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 64,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/latham.thomas.jpg",
        "name": "Latham Thomas",
        "job": "Doula, founder of Mama Glow",
        "sector": "Community",
        "twitterAccount": "mamaglow_mgff",
        "location": " New York City",
        "age": 39,
        "bio": "[Latham Thomas](https://theglowup.theroot.com/reclaiming-our-birthright-latham-thomas-is-protecting-1837727719) wants to help women reclaim childbirth—particularly black women, who experience maternal health crises at [a much higher rate than any other group](https://www.theroot.com/tag/black-maternal-health). Latham is the founder of [Mama Glow](https://mamaglow.com/about/), a &quot;maternity lifestyle brand committed to supporting women along the childbearing continuum.&quot; She was honored as one of [Oprah&#39;s Super Soul 100](http://www.supersoul.tv/supersoul-100/soul-teachers/latham-thomas), a collection of leaders who are &quot;using their voices and talent to elevate others.&quot;A graduate of Columbia University and the Institute for Integrative Nutrition, Latham is the author of _Mama Glow: A Hip Guide to a Fabulous and Abundant Pregnancy_ and _OWN YOUR GLOW: A Soulful Guide to Luminous Living and Crowning the Queen Within_.",
        "website": "https://mamaglow.com/",
        "claimToFame": "The Mama Glow founder is working to ensure that women—particularly black women—have safe and positive childbirth experiences.",
        "influence": 155.6,
        "reach": 10.09,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/glowmaven/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "4I4XMVbVHjLUwzDOCZC9vB",
        "type": "Entry",
        "createdAt": "2019-09-19T21:18:25.647Z",
        "updatedAt": "2019-09-25T17:22:30.664Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 43,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/law.roach.jpg",
        "name": "Law Roach",
        "job": "Stylist",
        "sector": "Entertainment",
        "twitterAccount": "luxurylaw",
        "location": "Los Angeles",
        "age": 40,
        "bio": "Law Roach has worked with just about everyone in Hollywood. As one of the top stylists in the business, Roach has remixed the looks of stars like Céline Dion, Tiffany Haddish, Mary J. Blige, Ariana Grande and [Tracee Ellis Ross](https://www.instagram.com/p/B2PJ-fMjmas/). A self-proclaimed &quot;image architect&quot; who made The Hollywood Reporter&#39;s list of most powerful stylists in Hollywood in 2017 and [again this year](https://www.hollywoodreporter.com/lists/25-top-stylists-hollywood-2019-1192120/item/rebecca-corbin-murray-power-stylists-2019-1192122), Law partnered with his frequent collaborator, Zendaya, as the creative director for the young actor&#39;s [Tommy X Zendaya](https://usa.tommy.com/en/tommy-x-zendaya) clothing line, which was featured at the famed [Apollo Theater](https://www.instagram.com/p/B2MYfPfD3pc/) during New York Fashion Week in September. He was also named stylist of the year at Harlem's Fashion Row awards, an honor that touched Law deeply. &quot;I&#39;m just so honored to be recognized by my own people,&quot; [he said](https://theglowup.theroot.com/black-is-the-new-black-harlems-fashion-row-presented-a-1837929898). &quot;I feel like I&#39;m home.&quot;",
        "claimToFame": "As one of the top stylists in Hollywood, Law reached a new career milestone after serving as creative director for Zendaya&#39;s Tommy X Zendaya line.",
        "influence": 172.7,
        "reach": 12.42,
        "substance": 7.6,
        "instagramUrl": "https://www.instagram.com/luxurylaw/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "xqSKoHu7QNleRsj1OAgN1",
        "type": "Entry",
        "createdAt": "2019-09-17T18:38:26.365Z",
        "updatedAt": "2019-09-24T22:59:41.757Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 79,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/MiAngel.Cody.jpg",
        "name": "MiAngel Cody",
        "job": "Lawyer, founder of the Decarceration Collective",
        "sector": "Community",
        "twitterAccount": "DecarcerateNow",
        "location": "Chicago",
        "age": 39,
        "bio": "MiAngel Cody is fighting to break America&#39;s addiction to incarceration. Along with fellow attorney Brittany K. Barnett (also an honoree on this year&#39;s list), Cody launched the [&quot;90 Days of Freedom&quot; campaign](https://miangelcody.com/tdc-homepage/the-attorneys/miangelcody/), which resulted in successfully winning clemency for 17 federal prisoners who were sentenced to life in prison, a campaign [that caught the attention of Kim Kardashian](https://www.complex.com/pop-culture/2019/05/kim-kardashian-legal-team-help-free-17-prisoners-90-days). Cody is the founder of [the Decarceration Collective](https://miangelcody.com/tdc-homepage/the-attorneys/), a criminal defense firm dedicated to overturning life sentences for people with drug convictions.",
        "website": "https://miangelcody.com/",
        "claimToFame": "Cody, who has been fighting to end mass incarceration, co-launched the &quot;90 Days of Freedom&quot; campaign, which successfully won clemency for 17 federal prisoners.",
        "influence": 141.1,
        "reach": 8.29,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/thedecarcerationcollective/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3orsY5DScFoLuZpDmGYpz7",
        "type": "Entry",
        "createdAt": "2019-09-18T01:42:33.366Z",
        "updatedAt": "2019-09-24T23:12:02.365Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 93,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/marcus.bullock.jpg",
        "name": "Marcus Bullock",
        "job": "App developer, entrepreneur",
        "sector": "Community",
        "twitterAccount": "_marcus_bullock",
        "location": "Washington, D.C.",
        "age": 39,
        "bio": "Bullock is using his lived experience to [help those who are incarcerated](https://theundefeated.com/features/marcus-bullock-creator-of-flikshop-app-wants-prisoners-to-stay-connected-to-their-families/). When he was just 15, the Washington, D.C., native was sentenced as an adult to eight years in a maximum security prison for his involvement in a carjacking. It was a long, lonely stretch, and [the letters he received from his mom](https://www.forbes.com/sites/devinthorpe/2018/03/13/entrepreneur-launches-tech-company-to-help-incarcerated-people-connect-with-family/#1a04d2cf720a) kept him connected to something greater and helped prevent a cycle of recidivism when he got out. Now a tech entrepreneur and activist, Bullock [developed an app called Flikshop](https://www.flikshop.com/) as a social media platform that lets loved ones print and mail picture postcards to the incarcerated men and women at institutions nationwide. John Legend is an investor, as is former NBA baller Baron Davis, and Bullock is using [the attention on his invention](https://www.youtube.com/watch?v=ycCZrtCkDY8) to push an agenda to end mass incarceration and, in the meantime, [create equitable opportunities for returning citizens](https://video.foxnews.com/v/6049176398001/#sp=show-clips) when they&#39;re paroled or released.",
        "website": "https://www.flikshop.com/",
        "claimToFame": "Bullock invented Flikshop, a type of social media platform for the incarcerated, to keep them connected to their families and communities during their sentences.",
        "influence": 122.8,
        "reach": 7.05,
        "substance": 6.8,
        "instagramUrl": "https://www.instagram.com/flikshop/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "4d0zrxhV9F3XWwe3B8WG0T",
        "type": "Entry",
        "createdAt": "2019-09-17T21:58:19.829Z",
        "updatedAt": "2019-09-18T16:12:42.183Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 84,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/dantley.davis.jpg",
        "name": "Dantley Davis",
        "job": "Vice president of design and research, Twitter",
        "sector": "STEM",
        "twitterAccount": "dantley",
        "location": "San Francisco",
        "age": 42,
        "bio": "Dantley Davis has worked for almost every major tech company in the industry. [Netflix, PayPal, Yahoo, Facebook](https://www.linkedin.com/in/dantley)—Davis has worked his way up from being a user interface designer to the head of development at some of Silicon Valley&#39;s biggest companies. This year, Davis was named vice president of design and research at Twitter, where he will lead the company&#39;s march toward the future.\n",
        "claimToFame": "The seasoned tech professional was recently tapped to head up research and design for Twitter.",
        "influence": 138.8,
        "reach": 8.02,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/dantley/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1O0ZF6S8jZyos9dwBMMYMX",
        "type": "Entry",
        "createdAt": "2019-09-10T17:07:16.755Z",
        "updatedAt": "2019-09-24T22:25:16.560Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 58,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568652440/kwame.onwuachi2_guuky4.jpg",
        "name": "Kwame Onwuachi",
        "job": "Executive chef",
        "sector": "Business",
        "twitterAccount": "ChefKwame",
        "location": "Washington, D.C.",
        "age": 29,
        "bio": "His story is so compelling that [one reviewer](https://www.washingtonpost.com/lifestyle/food/kwame-onwuachis-new-memoir-is-a-must-read-on-what-its-like-to-be-a-young-black-chef-in-america/2019/03/29/51164000-50d6-11e9-88a1-ed346f0ec94f_story.html) suggested Onwuachi&#39;s memoir, [_Notes From a Young Black Chef_](https://www.amazon.com/Notes-Young-Black-Chef-Memoir/dp/1524732621), should be required reading. Hollywood, always eager to cash in on a good autobiographical story, is adapting the book for film with [Lakeith Stanfield reportedly cast as the young black chef himself](https://www.eater.com/2019/7/16/20695906/kwame-onwuachi-notes-from-a-young-black-chef-movie-lakeith-stanfield). At the center of his story are the culinary talents that have been the keystone of the [_Top Chef_](https://www.bravotv.com/people/kwame-onwuachi) [alum&#39;s signature West African and Caribbean flavor](https://www.bravotv.com/people/kwame-onwuachi) and his stellar career in kitchens from New York City to the nation&#39;s capital. In May, Onwuachi, the executive chef at Kith and Kin in Washington, D.C., was honored with the uber-illustrious James Beard Award for Rising Star Chef of the Year. Two months later, the New York Times called him one of [16 black chefs changing food in America](https://www.nytimes.com/interactive/2019/07/16/dining/black-chefs-restaurants-food.html?smid=ig-nytcooking&amp;utm_source=curalate_like2buy&amp;utm_medium=curalate_like2buy_gnauQ5q1__216165fc-7675-47a4-aff1-6793cc48295f&amp;crl8_id=216165fc-7675-47a4-aff1-6793cc48295f). And the man behind the menu is just getting started—he hasn&#39;t even turned 30 yet.",
        "website": "https://kithandkindc.com/",
        "claimToFame": "Onwuachi had a big year in and out of the kitchen—his just-released memoir was optioned for a film and he was named the Rising Star Chef of the Year by the James Beard Foundation, one of the highest honors in the food world.\n",
        "influence": 161.9,
        "reach": 10.92,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/chefkwameonwuachi/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2TuOdU2gn81CJNAoG43sSt",
        "type": "Entry",
        "createdAt": "2019-09-07T17:59:18.671Z",
        "updatedAt": "2019-09-13T16:34:41.587Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 11,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/Alysia_Montano.jpg",
        "name": "Alysia Montaño",
        "job": "Track champion",
        "sector": "Sports",
        "twitterAccount": "alysiamontano",
        "location": "California",
        "age": 33,
        "bio": "Her star rose as an 800-meter track star, Olympian and world-class athlete, and it shone even brighter in the 2014 USA Outdoor Track and Field Championships when she competed [eight months pregnant](https://www.washingtonpost.com/news/early-lead/wp/2014/06/27/olympian-alysia-montano-runs-an-800-meter-race-while-34-weeks-pregnant/) with her first child (she did [the same with her second child](https://www.usatoday.com/story/sports/olympics/2017/06/23/alysia-montano-competes-again-while-pregnant-nationals/422631001/) in 2017). This year, appropriately on Mother&#39;s Day, Montaño became another kind of champion when she [called out Nike, Asics and other major brands](https://www.nytimes.com/2019/05/12/opinion/nike-maternity-leave.html) for reducing or stopping pay to female athletes who are pregnant or on maternity leave. Her courage to share her story in the New York Times defied the implied and explicit confidentiality that shrouds gender discrimination and allows multibillion dollar companies to strongarm women into choosing between having a family and living a dream. After Montaño, now a mother of two, exposed Nike&#39;s contradictory practices, other female athletes—including Allyson Felix, who is also an honoree this year—came forward with similar experiences and just weeks later, [the company implemented a new policy](https://www.si.com/olympics/2019/05/23/nike-maternity-protection-sponsorships-contract-allyson-felix-alysia-montano) in its sponsorship deals.",
        "website": "http://www.alysiamontano.com/",
        "claimToFame": "Montaño put her career and future sponsorships on the line to fight for women by exposing Nike&#39;s discriminatory contracts against pregnant athletes.\n",
        "influence": 207.3,
        "reach": 11.61,
        "substance": 7.8,
        "instagramUrl": "https://www.instagram.com/alysiamontano/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6LTGMylYt7xObjaGrde2Xu",
        "type": "Entry",
        "createdAt": "2019-09-07T18:39:09.659Z",
        "updatedAt": "2019-09-23T14:37:10.620Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 6,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 73,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568650817/candice.payne2_ytcj0a.jpg",
        "name": "Candice Payne",
        "job": "Entrepreneur and philanthropist",
        "sector": "Community",
        "location": "Chicago",
        "age": 34,
        "bio": "When [a polar vortex blitzed Chicago in January](https://www.vice.com/en_us/article/yw8vnb/chicago-storm-photos-videos-polar-vortex-freezing-midwest-vgtrn), the city&#39;s legendary winter temps were reportedly more frigid than the South Pole and Mount Everest. Payne, a serial entrepreneur and real estate developer, [thought of the homeless people confronting the cold](https://www.npr.org/2019/02/02/690916753/meet-the-chicago-woman-who-rented-hotel-rooms-for-the-homeless-during-frigid-pol)—some of them young, elderly or disabled—and got the idea to pay for 30 hotel rooms with her own American Express card to shelter at least 40 people from the minus 27 temperatures for the night. She posted on Instagram, offering to pay anyone with a large vehicle to help with transportation and it went viral. Her [selfless gesture turned into a community movement](https://www.npr.org/2019/02/02/690916753/meet-the-chicago-woman-who-rented-hotel-rooms-for-the-homeless-during-frigid-pol) that secured 60 hotel rooms for four nights, and three meals per day per person. A native Chicagoan who initially remained anonymous, Payne then launched [Action for a Cause](https://actionforacausenow.org/) to transform shipping containers into sleeping quarters and restore multi-unit buildings to create more permanent housing solutions for people in her city.",
        "website": "https://candicesellschicago.com/",
        "facebookUrl": "https://www.facebook.com/Candicepayne85",
        "claimToFame": "Payne saved lives by housing dozens of homeless people during a record-breaking cold spell in Chicago.\n",
        "influence": 146.5,
        "reach": 5.24,
        "substance": 8,
        "instagramUrl": "https://www.instagram.com/CANDICEPAYNE_/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1lh3KhTuuAmCRjfakeAGm7",
        "type": "Entry",
        "createdAt": "2019-09-18T00:43:59.858Z",
        "updatedAt": "2019-09-24T22:15:10.926Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 51,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/matthew.cherry.jpg",
        "name": "Matthew Cherry",
        "job": "Writer, director",
        "sector": "Entertainment",
        "twitterAccount": "matthewacherry",
        "location": "Los Angeles",
        "age": 37,
        "bio": "Matthew Cherry is a hustler. When his NFL career ended in 2007, Cherry moved to Los Angeles to try his hand in Hollywood. After first working as [a production assistant on over 40 commercials](http://www.matthewacherry.com/about), Cherry turned his attention to music videos before finally writing and directing his first feature film, _The Last Fall_. Cherry&#39;s second film, _9 Rides,_ debuted at the SXSW Film Festival in 2016. In 2017, Cherry [raised over $280,000 on Kickstarter](https://www.kickstarter.com/projects/matthewacherry/hair-love-animated-short-film) to bring his animated film, _Hair Love_—the story of a black father, his daughter and her natural hair—to the big screen. This year, the short came to fruition and [was screened](https://www.npr.org/2019/08/24/754052328/movie-hair-love) right before showings of *The Angry Birds Movie 2*.",
        "website": "http://www.matthewacherry.com/",
        "claimToFame": "The former NFL player released _Hair Love_, [an animated short film](http://www.matthewacherry.com/hair-love) that centers around a black father, his daughter and her natural hair.",
        "influence": 167.7,
        "reach": 11.71,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/matthewacherry/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3DPlVMZR6CJYXjGbNZ298E",
        "type": "Entry",
        "createdAt": "2019-09-10T18:28:23.676Z",
        "updatedAt": "2019-09-13T16:33:31.152Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 8,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/rodney.robinson.jpg",
        "name": "Rodney Robinson",
        "job": "Educator",
        "sector": "Community",
        "twitterAccount": "RodRobinsonRVA",
        "location": "Richmond, Va.",
        "age": 40,
        "bio": "A voice for students who are chronically unheard and undervalued, Robinson—his students call him &quot;Big Rob&quot;—teaches up to 60 young men, most of them black and brown, at the [Virgie Binford Education Center](https://www.rvaschools.net/VBEC), a school inside the Richmond Juvenile Justice Center. His ardent advocacy and excellence in education earned him [the 2019 National Teacher of the Year Award](https://ccsso.org/national-teacher-of-the-year), the most prestigious honor in the field. The 19-year veteran of Richmond Public Schools collaborated with Pulitzer Prize winner James Forman Jr. to develop a social studies-based curriculum that gives his 6th to 12th grade students, many who have experienced multiple transitions and traumas, an in-depth understanding of the justice and prison systems. His unique approach has inspired other black men to become teachers and [empowers the young men under his leadership](https://www.youtube.com/watch?v=SI5X-6qTefU) to understand their experiences, make better choices and become social advocates in their communities. ",
        "claimToFame": "Robinson, a 19-year veteran of Virginia&#39;s Richmond Public Schools, won the 2019 National Teacher of the Year Award.\n",
        "influence": 218.5,
        "reach": 8.33,
        "substance": 8.7
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1j3huOCj3nMjHF2e3qtse6",
        "type": "Entry",
        "createdAt": "2019-09-19T20:54:02.045Z",
        "updatedAt": "2019-09-23T23:46:28.144Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 34,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/kid.fury.jpg",
        "name": "Kid Fury",
        "job": "Co-host of The Read podcast, TV show",
        "sector": "Entertainment",
        "twitterAccount": "kidfury",
        "location": "New York City",
        "age": 31,
        "bio": "Kid Fury, born Gregory A. Smith, has come a long way from [his YouTube roots](https://www.nytimes.com/2016/01/16/arts/television/kid-fury-of-the-read-from-digital-realm-to-the-stage.html). After rolling out his own vlog, &quot;[Furious Thoughts](https://www.youtube.com/user/TheFuryTV/videos)&quot; back in 2010, the Miami native teamed up with Crissle West (also an honoree on the list) to host _The Read_, one of the most popular podcasts on the air. Known for his irreverent, rapid-fire commentary, Fury parlayed his digital shows into live events, touring with West for _The Read Live_ and honing his stand-up comedy chops. Now the pair are bringing their popular podcast to the small screen on Fuse TV in October.",
        "website": "http://www.thekidfury.com/",
        "claimToFame": " Fury and partner-in-podcasting Crissle West are bringing their popular podcast _The Read_ to Fuse TV this October.",
        "influence": 179.7,
        "reach": 12.01,
        "substance": 7.2,
        "instagramUrl": "https://www.instagram.com/kidfury/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6LGdE8su6bP4f7HqtHHM4f",
        "type": "Entry",
        "createdAt": "2019-09-18T01:03:26.212Z",
        "updatedAt": "2019-09-18T16:19:20.734Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 57,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/Rhiana.Gunn-Wright.jpg",
        "name": "Rhiana Gunn-Wright",
        "job": "Policy director, New Consensus",
        "sector": "Politics",
        "twitterAccount": "rgunns",
        "location": "Washington, D.C.",
        "age": 30,
        "bio": "At the intersection of economic equity and climate change, [the Yale-educated national policy expert](https://www.essence.com/feature/she-the-people-rhiana-gunn-wright-green-new-deal/) has always questioned social and governmental rules and the motives of the people who implement them. Now as an architect of [the Green New Deal](https://www.npr.org/2019/02/07/691997301/rep-alexandria-ocasio-cortez-releases-green-new-deal-outline), an ambitious framework co-introduced by Rep. Alexandria Ocasio-Cortez that will create jobs and protect vulnerable communities as it combats the core causes of climate change, Gunn-Wright is leading the conversation in a moment when people are finally listening. At [New Consensus](https://newconsensus.com/green-new-deal/), the black-owned think tank in Chicago that developed the deal&#39;s 10-year plan and its five solution-based pillars, she&#39;s policy director and a voice for the millions of black Americans who are [disproportionately affected by pollution](https://www.sciencedaily.com/releases/2019/03/190311152735.htm). The Senate voted against the plan in March but with the Rhodes Scholar and one-time intern for Michelle Obama as its advocate, it&#39;s not going anywhere—and neither is she.",
        "claimToFame": "As one of the architects of the Green New Deal, Gunn-Wright is a leading thinker, doer and change-maker in policies that affect our climate and communities.",
        "influence": 162.2,
        "reach": 9.26,
        "substance": 7.3,
        "instagramUrl": "https://www.instagram.com/rgunner/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2GZbXLYI03SHTfghTkNjP5",
        "type": "Entry",
        "createdAt": "2019-09-18T23:36:44.601Z",
        "updatedAt": "2019-09-24T22:23:01.071Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 56,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/adam_serwer.jpg",
        "name": "Adam Serwer",
        "job": "Staff writer, The Atlantic",
        "sector": "Media",
        "location": "Washington, D.C.",
        "age": 40,
        "bio": "In a political moment that is a raw patch of inhumanity, Serwer&#39;s [richly textured and thoughtful analysis of race](https://www.theatlantic.com/author/adam-serwer/) in the Trump administration and the coinciding rise of white nationalism is a light. He has a gift for digging into the &quot;why&quot; of what&#39;s happening in viral pieces like &quot;[The Cruelty Is the Point](https://www.theatlantic.com/ideas/archive/2018/10/the-cruelty-is-the-point/572104/),&quot; which explores Trump, his supporters and the power they channel directly from the suffering of other people. He&#39;s also adept at pulling out historical similarities that remind readers that resilience and perseverance are part of our cultural makeup and, although bruised and injured, we will survive this, too. For his thoughtful coverage of politics at The Atlantic, Serwer was awarded the 2019 [Hillman Prize for Opinion and Analysis Journalism](http://hillmanfoundation.org/hillman-prizes/2019-hillman-prize-opinion-analysis-journalism).",
        "website": "https://www.theatlantic.com/author/adam-serwer/",
        "claimToFame": "Serwer&#39;s insightful political coverage of Trump and his rabid supporters is a gift to the field of journalism.",
        "influence": 162.3,
        "reach": 10.97,
        "substance": 7.3
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5lotHwsO9tIn4I08gjlxPL",
        "type": "Entry",
        "createdAt": "2019-09-19T14:44:47.888Z",
        "updatedAt": "2019-09-20T18:40:00.751Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 1,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/stacey.abrams.jpg",
        "name": "Stacey Abrams",
        "job": "Politician",
        "sector": "Politics",
        "twitterAccount": "staceyabrams",
        "location": "Atlanta",
        "age": 45,
        "bio": "A year after a shady election denied her the chance to become America&#39;s first black female governor, Abrams is still that chick causing all that conversation. She never [officially conceded her loss](https://www.msn.com/en-us/news/politics/why-stacey-abrams-still-wont-concede/ar-AAHl4hB) because that would imply the process was fair. And it wasn&#39;t. But the platform of equity and justice she stood on during her campaign? She&#39;s still on that, except now she&#39;s laser-focused on combating voter suppression in battleground states through her [Fair Fight 2020 initiative](https://fairfight.com/fair-fight-2020/) to protect people of color, the poor, LGBTQ folks and seniors from the tricks of the imbalanced status quo. Abrams may not be in the race for any political seat—she announced she wouldn&#39;t be running for president, though she&#39;d be a standout if she did—but she is open to being a Democratic candidate&#39;s [vice presidential running mate](https://www.nytimes.com/2019/08/14/us/politics/stacey-abrams-vice-president.html)—and any one of the 50-eleven candidates running would be lucky to have her. No matter what title she holds or if she has no title at all, she&#39;s doing the work we always want politicians to be doing.",
        "website": "https://fairfight.com/",
        "claimToFame": "Still fighting for the people—she&#39;s always fighting for the people—Abrams launched the Fair Fight 2020 initiative to make sure voters aren&#39;t illegally silenced or disenfranchised in the upcoming election.",
        "influence": 250.5,
        "reach": 15.31,
        "substance": 8,
        "instagramUrl": "https://www.instagram.com/staceyabrams/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5RB0j71ZtqtdbxgB5KZMYr",
        "type": "Entry",
        "createdAt": "2019-09-10T18:00:50.251Z",
        "updatedAt": "2019-09-13T16:33:57.523Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 48,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/mahershala.ali.jpg",
        "name": "Mahershala Ali",
        "job": "Actor",
        "sector": "Entertainment",
        "location": "Los Angeles",
        "age": 45,
        "bio": "Ali is one of those dexterous actors who can [bend his ineffable talent around any role](https://time.com/collection/100-most-influential-people-2019/5567869/mahershala-ali/). His character on the third season of HBO&#39;s _True Detective_ demanded he interpret Wayne Hays—originally [scripted to be a white man](https://www.vanityfair.com/hollywood/2018/12/true-detective-season-3-mahershala-ali-hbo)—as a 35, then 45, then 70-year-old, and Ali [brilliantly breathed life into each stage](https://www.lamag.com/culturefiles/mahershala-ali-true-detective/) to essentially play three characters in one, earning an [Emmy nomination](https://www.awardscircuit.com/2019/09/06/emmy-circuit-mahershala-ali/) along the way. In February, he earned an [Oscar for best supporting actor](https://www.youtube.com/watch?v=RQhIGLHCt24) for his portrayal of musical genius Dr. Donald Shirley in _Green Book_, his second time earning the honor after his 2017 win for _Moonlight_. The victory was also the first time a black actor won two Oscars in the same category. Next year, that versatility is going to shine again—Ali has been cast to [reprise Wesley Snipe&#39;s role](https://www.youtube.com/watch?v=aeOyXwo-r_k) in Marvel&#39;s _Blade_ reboot and kill vampires with the same signature bravura.",
        "claimToFame": "Ali won an Academy Award for best supporting actor for a second time in 2019 for his work in _Green Book_ and earned an Emmy nomination for his role in HBO&#39;s _True Detective_.\n",
        "influence": 168.9,
        "reach": 11.88,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/mahershalaali/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5U8dyL79cyVNLHt8tmz6FC",
        "type": "Entry",
        "createdAt": "2019-09-17T22:55:44.428Z",
        "updatedAt": "2019-09-23T23:41:46.276Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 33,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568827487/jaime.harrison2_ct1zls.jpg",
        "name": "Jaime Harrison",
        "job": "Democratic candidate for Senate, South Carolina",
        "sector": "Politics",
        "twitterAccount": "harrisonjaime",
        "location": "Columbia, S.C.",
        "age": 43,
        "bio": "Jamie Harrison is looking to make history once again. In 2013, the Yale University grad became [the first African American](https://www.nytimes.com/2019/05/29/us/politics/jaime-harrison-lindsey-graham.html) to become the chairman of the Democratic Party in South Carolina. Prior to assuming leadership of his home state&#39;s party, Harrison served as [Rep. Jim Clyburn&#39;s director of floor operations](https://thetandd.com/news/local/orangeburg-native-seeks-chairmanship-of-s-c-democrats/article_ee03bc22-74d1-11e2-a94e-0019bb2963f4.html) while the congressman was the Majority Whip. Harrison also worked as a lobbyist for [the Podesta Group](https://www.postandcourier.com/politics/state_politics/harrison-expected-to-lead-dems/article_4f5898b4-59dd-539d-acb5-e5119295f022.html). Earlier this year, Harrison announced his candidacy for U.S. Senate from the Palmetto State. If he unseats Republican Sen. Lindsay Graham, Harrison would become the first Democrat to win statewide office in South Carolina [since 2006](https://www.nytimes.com/2019/05/29/us/politics/jaime-harrison-lindsey-graham.html). It&#39;s a Herculean challenge but Harrison is ready to battle.",
        "website": "https://jaimeharrison.com/",
        "claimToFame": "Harrison is challenging Trump ally Republican Lindsay Graham for South Carolina&#39;s U.S. Senate seat.",
        "influence": 181.5,
        "reach": 11.6,
        "substance": 7.3,
        "instagramUrl": "https://www.instagram.com/harrisonjaime/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "u3FrcMmrQpqcJJ6TsVlla",
        "type": "Entry",
        "createdAt": "2019-09-19T21:00:02.370Z",
        "updatedAt": "2019-09-24T22:30:26.356Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 59,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/kiese.laymon.jpg",
        "name": "Kiese Laymon",
        "job": "Author, professor",
        "sector": "Arts",
        "twitterAccount": "kieselaymon",
        "location": "Oxford, Miss.",
        "age": 45,
        "bio": "University of Mississippi professor and writer [Kiese Laymon](https://www.kieselaymon.com/about) has borne the weight of being a black man in America. Raised by a strict mother, Laymon struggled with his weight as a child while also dealing with the trauma of sexual abuse, white supremacy and toxic masculinity. His coming-of-age story is captured in his searing, unrelenting biography, _Heavy: An American Memoir_, which took home the [Andrew Carnegie Medal for Excellence in Nonfiction](https://www.colorlines.com/articles/kiese-laymon-wins-andrew-carnegie-medal-gives-prize-money-young-mississippians). The book has been widely praised, with [one critic calling it](https://www.latimes.com/books/la-ca-jc-laymon-heavy-20181012-story.html) &quot;one of the most important and intense books of the year because of the unyielding, profoundly original and utterly heartbreaking way it addresses and undermines expectations for what exactly it&#39;s like to possess and make use of a male black body in America.&quot;",
        "claimToFame": "The professor and best-selling author offers a searing depiction of blackness and masculinity in his powerful memoir, _Heavy_.",
        "influence": 159.2,
        "reach": 10.55,
        "substance": 7.1,
        "instagramUrl": "https://www.instagram.com/kieselaymon/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2q4WuWz6rE46knAIHWydcm",
        "type": "Entry",
        "createdAt": "2019-09-17T22:44:49.332Z",
        "updatedAt": "2019-09-20T18:52:14.798Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 7,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/ilhan.omar.jpg",
        "name": "Ilhan Omar",
        "job": "U.S. Representative, Minnesota",
        "sector": "Politics",
        "twitterAccount": "Ilhan",
        "location": "Washington, D.C., and Minnesota",
        "age": 37,
        "bio": "Even before she was sworn into the U.S. House of Representatives in 2018, freshman Rep. Illhan Omar (D-Minn.) made history. Omar was the first black Muslim woman elected to Congress (and one of two Muslim women to serve in the House, along with fellow freshman Rep. Rashida Talib from Michigan), and she&#39;s also the first person to rock a hijab on the floor of the House. An outspoken progressive, Omar is a member of &quot;the Squad&quot;—along with Reps. Talib, Ayanna Pressley (D-Mass.) and Alexandria Ocasio-Cortez (D-N.Y.)—whose push to pass bold, progressive policies have drawn the ire of President Donald Trump—and even some fellow Democrats.",
        "website": "https://omar.house.gov/",
        "claimToFame": "A member of the group known as &quot;the Squad,&quot; Omar is one of the most outspoken progressives in the House of Representatives.",
        "influence": 219.4,
        "reach": 16.05,
        "substance": 7.4
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6JtCmUuHgqBkPFG3urKpQE",
        "type": "Entry",
        "createdAt": "2019-09-18T00:09:59.852Z",
        "updatedAt": "2019-09-24T22:50:46.208Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 63,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/kezia.williams.jpg",
        "name": "Kezia Williams",
        "job": "CEO, Black upStart",
        "sector": "Business",
        "twitterAccount": "KeziaMW",
        "location": "Washington, D.C.",
        "age": 37,
        "bio": "She punctuates just about every photo with a black power fist and her social media is a deep well of advice and information to help millennials [level-up their wealth and break financial cycles](https://www.essence.com/lifestyle/money-career/entrepreneurship/3-things-black-upstart-wants-you-know-about-entrepreneurship/). Williams means business about business. The Richmond, Va., native founded [Black upStart](https://www.theblackupstart.com/), an empowerment program that supports and trains young African-American entrepreneurs to start and grow sustainable small businesses. Of the 200 creators she&#39;s helped, 41 percent are still in business and 50 percent now employ other people, as well. Four years ago, Williams was enlisted by the United Negro College Fund to launch a $25 million entrepreneurship initiative for black undergraduates, and expanded it from just 44 students to 350 at 90 colleges and universities. The bottom line for all of her ventures and collaboration is her passion for pushing black folks beyond boundaries to get money for now, build generational wealth for later.",
        "website": "https://www.theblackupstart.com",
        "claimToFame": "Williams is the millennial money and business whisperer, and has built a thriving business out of helping other young black people build their own thriving businesses, too.",
        "influence": 157.2,
        "reach": 9.2,
        "substance": 7.2,
        "instagramUrl": "https://www.instagram.com/keziamw/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5gpABWWuEh0qlLlybtFiJe",
        "type": "Entry",
        "createdAt": "2019-09-17T19:19:57.592Z",
        "updatedAt": "2019-09-25T17:39:55.756Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 83,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1569427157/brandi.collins-dexter2_fhflle.jpg",
        "name": "Brandi Collins-Dexter",
        "job": "Senior campaign director, Color of Change",
        "sector": "Community",
        "twitterAccount": "brandingbrandi",
        "age": 38,
        "bio": "Brandi Collins-Dexter has no problem standing up against the powerful. As the senior campaign director of Color for Change, Collins-Dexter led [the campaign to get Facebook](https://colorofchange.org/press_release/color-of-change-secures-agreement-from-facebook-to-create-civil-rights-accountability-infrastructure/) to conduct a civil rights audit to better understand the impact its policies have on vulnerable communities. This led the tech giant to create a civil rights accountability infrastructure headed by Facebook Chief Operating Officer Sheryl Sandberg. Collins-Dexter even [appeared before Congress](https://www.washingtonpost.com/news/powerpost/paloma/the-technology-202/2019/02/26/the-technology-202-advocate-urges-congress-to-protect-digital-rights-of-people-of-color-as-it-crafts-privacy-bill/5c744bc31b326b71858c6c3a/) to testify about how the sweeping data collection by tech companies affects online privacy. Earlier this year, Collins-Dexter was named [one of five fall fellows](https://shorensteincenter.org/fall-2019-fellows-announcement/) of the Shorenstein Center at Harvard University, where she will pen a paper on &quot;the digital ecosystem and how it has forever altered the political, economic, sociological and psychological ways in which we engage offline.&quot;",
        "website": "https://colorofchange.org/",
        "claimToFame": "Collins-Dexter has worked tirelessly to hold big tech firms like Facebook accountable for policies that disportionately affect communities of color.",
        "influence": 139,
        "reach": 6.11,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/brandingbrandi/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "U1PHuA5BhQdYr1dafT76e",
        "type": "Entry",
        "createdAt": "2019-09-10T18:37:58.966Z",
        "updatedAt": "2019-09-16T16:24:09.929Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 40,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568650817/Zach_Stafford_retouch_baxxvk.jpg",
        "name": "Zach Stafford",
        "job": "Editor-in-chief, The Advocate",
        "sector": "Media",
        "twitterAccount": "ZachStafford",
        "location": "Los Angeles",
        "age": 29,
        "bio": "In December, right before the holiday season swallowed the remainder of the year, Stafford was presented with his next best career opportunity. It emerged, ironically enough, after an archaic and tone-deaf comment from Scott Chen, his de facto boss and president of Grindr, a popular gay dating app. Stafford was then the company&#39;s chief content officer and editor of its magazine, INTO, and when [Chen posted comments on Facebook](https://www.intomore.com/impact/grindr-president-says-marriage-is-holy-matrimony-between-a-man-and-a-woman-in-deleted-social-media-post) that were interpreted by many as an opposition to same-sex marriage, INTO was one of the first publications to cover the expression of ignorance from its own leadership. Stafford resigned just weeks later, [taking the high road](https://www.intomore.com/you/a-goodbye-letter-from-the-editor-in-chief-of-into) and his [award-winning journalistic skills](http://chicago.gopride.com/news/article.cfm/articleid/96522400) to a loftier, history-making role as [the first black editor-in-chief of The Advocate](https://www.nbcnews.com/feature/nbc-out/advocate-names-first-black-editor-chief-its-50-year-history-n950641), the oldest LGBTQ magazine in the country, where his stellar editorial judgment will build on the publication&#39;s five decades of reportage.",
        "claimToFame": "Stafford, an award-winning journalist, is the first African American to be named editor-in-chief of The Advocate, the oldest LGBTQ magazine in circulation.",
        "influence": 173.3,
        "reach": 9.49,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/zachstaff/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2dIgIKabRRxCpQyczbMfvE",
        "type": "Entry",
        "createdAt": "2019-09-10T13:53:35.887Z",
        "updatedAt": "2019-09-24T22:22:01.617Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 7,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 55,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/jordan.peele.jpg",
        "name": "Jordan Peele",
        "job": "Writer, producer, director",
        "sector": "Entertainment",
        "twitterAccount": "jordanpeele",
        "location": "Los Angeles",
        "age": 40,
        "bio": "If there is such a thing as the sophomore curse, it didn&#39;t attach itself to Jordan Peele. _Get Out_ grossed more than $254 million in 2017, making it the year's most profitable movie, and expectations were extra high for his followup project. The multihyphenate filmmaker delivered with _Us_, a matrix of plot twists and indirect references that were as [fun to dissect, discuss and debate](https://www.esquire.com/entertainment/movies/a27028615/twist-ending-explained-jordan-peele-interview/) as it was to watch Lupita and Winston take on their enemy doppelgängers. So much so, in fact, Peele&#39;s second feature also raked in $254 million and [broke records](https://www.wired.com/story/jordan-peele-us-box-office/) as the biggest opening weekend for an original horror movie and the second-biggest opening for an R-rated film. His stamp is on TV, too, with his [CBS All-Access reboot of](https://www.cbs.com/shows/the-twilight-zone/) [_The Twilight Zone_](https://www.cbs.com/shows/the-twilight-zone/), a show he loved when he was a kid that he has now thrown his talents behind to revive as executive producer and on-screen narrator.",
        "website": "https://www.monkeypawproductions.com/",
        "claimToFame": "Peele solidified his mastery of the mind-bending horror flick with the record-breaking release of _Us_, his second feature film, and his reboot of _The Twilight Zone_.",
        "influence": 165.3,
        "reach": 16.28,
        "substance": 6.4,
        "instagramUrl": "https://www.instagram.com/jordanpeele/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2MRzgHG0zaSZTUkZLUbqfE",
        "type": "Entry",
        "createdAt": "2019-09-17T22:22:02.654Z",
        "updatedAt": "2019-09-24T00:07:58.487Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 38,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/elaine.welteroth.jpg",
        "name": "Elaine Welteroth",
        "job": "Author",
        "sector": "Media",
        "twitterAccount": "elainewelteroth",
        "location": "New York City",
        "age": 32,
        "bio": "When Elaine Welteroth [left Teen Vogue in 2018](https://www.refinery29.com/en-us/2018/01/187694/editor-in-chief-elaine-welteroth-leaving-teen-vogue), many wondered where she&#39;d end up. As the youngest editor-in-chief in Conde Nast history, Welteroth transformed the glossy into a &quot;woke&quot; publication that covered everything from sex and reproductive rights to politics. After leaving, Welteroth signed with talent agency CAA and set her eyes on TV, writing for [_Grown-ish_](https://www.hollywoodreporter.com/news/departing-teen-vogue-editor-elaine-welteroth-signs-caa-1074179) and signing on as a judge on _Project Runway_. In 2019, she released [the bestselling book](https://www.elainewelteroth.com/book), _More Than Enough_, which has been described as &quot;part manifesto, part mememoir,&quot; a story of a barrier-breaking black woman who was often the only African American  in the room where decisions were made.\n",
        "website": "https://www.elainewelteroth.com/",
        "claimToFame": "The former Teen Vogue editor is the author of the bestselling essay collection, _More Than Enough_.",
        "influence": 176.7,
        "reach": 13,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/elainewelteroth/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5GPFbr4LJPBvtm7yWLnQf1",
        "type": "Entry",
        "createdAt": "2019-09-19T13:46:03.406Z",
        "updatedAt": "2019-09-23T23:17:57.743Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 14,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/lebron.james.jpg",
        "name": "LeBron James",
        "job": "NBA player, entrepreneur, philanthropist",
        "sector": "Sports",
        "twitterAccount": "KingJames",
        "location": "Los Angeles",
        "age": 34,
        "bio": "Every year is a big year when you&#39;re LeBron James. His [I Promise School](https://www.nba.com/article/2019/05/10/lebron-james-announces-1-million-grant-i-promise-gym), founded in 2018 for at-risk students in his native Akron, Ohio, [put up some exemplary scores of its own](https://www.usatoday.com/story/sports/nba/2019/04/12/students-lebron-james-school-generating-extraordinary-results/3446561002/). Ninety percent of the third and fourth graders there started the school year at least one grade level behind but ended this summer either meeting or exceeding their goals in math and reading. Win. His [SpringHill Entertainment](https://www.nba.com/article/2019/05/10/lebron-james-announces-1-million-grant-i-promise-gym) is a hub for [a full schedule of Hollywood projects](http://shentertainment.com/index.html), including the three-part Showtime documentary about the history of the NBA, _Shut Up and Dribble_, the upcoming _Space Jam_ sequel and _What&#39;s My Name: Muhammad Ali_, which premiered at the Tribeca Film Festival. Win. And although [his first season as a Laker](https://www.usatoday.com/story/sports/nba/2019/04/04/los-angeles-lakers-lebron-james-worst-season-ever/3352937002/) wasn&#39;t exactly extraordinary, King James gets to play basketball dad as his 14-year-old son, Bronny, finds his way as a superstar high school baller. Win infinity.",
        "website": "http://www.lebronjames.com/",
        "claimToFame": "Off the court, it was a successful year for James&#39; I Promise School and his SpringHill Entertainment.",
        "influence": 203.4,
        "reach": 19.34,
        "substance": 6.8,
        "instagramUrl": "https://www.instagram.com/kingjames/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1iL2pGjxPeaSAt2iTbzKQf",
        "type": "Entry",
        "createdAt": "2019-09-19T13:57:08.680Z",
        "updatedAt": "2019-09-20T12:43:26.125Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 82,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/maya.rupert.jpg",
        "name": "Maya Rupert",
        "job": "Campaign manager for Julian Castro",
        "sector": "Politics",
        "twitterAccount": "MayaRupert",
        "location": "Washington, D.C.",
        "age": 38,
        "bio": "Rupert has her work cut out for her because, even early on, this election cycle is going to be insane. We know that already. What the longtime justice fighter wants us to know is that she&#39;s [fire baptized and specifically cut out for the challenge](https://www.nytimes.com/2019/05/08/us/politics/julian-castro-2020-maya-rupert.html) of [navigating Julian Castro into the Oval Office](https://www.julianforthefuture.com/), which would make him the first Latino to do so. Few black women have managed the campaigns of presidential candidates—she is only the third, after Donna Brazile (Al Gore) and Maggie Williams (Hillary Clinton)—and at the moment, Castro isn&#39;t a frontrunner to win the Democratic nomination. Rupert isn&#39;t worried about all of that. She&#39;s just as invested in [proving that a black woman can get him there](https://www.theroot.com/what-it-means-that-a-black-woman-is-leading-julian-cast-1832525865) as she is in actually getting him there. This is her first time working on a campaign in any capacity but it&#39;s not her first time being scrutinized and doubted. She is, after all, a black woman. But for that same reason, she believes she can do it.",
        "claimToFame": "As the campaign manager for Julian Castro&#39;s presidential run, Rupert is only the third black woman to ever lead a candidate&#39;s electoral journey to the White House.",
        "influence": 140.1,
        "reach": 8.17,
        "substance": 7
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "41bSFwKfsdiv5eCyhP9SgH",
        "type": "Entry",
        "createdAt": "2019-09-10T17:25:22.136Z",
        "updatedAt": "2019-09-23T23:38:13.978Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 27,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704272/The%20Root%20100%202019/Lena.Waithe.jpg",
        "name": "Lena Waithe",
        "job": "Writer, producer, director, actor",
        "sector": "Entertainment",
        "twitterAccount": "LenaWaithe",
        "location": "Los Angeles",
        "age": 35,
        "bio": "Every year is a great year to be Lena Waithe, but it&#39;s been a particularly dope 12 months for the award-winning showrunner. [BET picked up](https://deadline.com/2019/04/lena-waithe-comedy-twenties-series-order-bet-1202595103/) a second season of _Boomerang_, her critically acclaimed TV reboot of the classic &#39;90s movie, and ordered _Twenties_, an eight-episode, half-hour comedy series Waithe wrote when she was in her 20s herself. She [rocked the red carpet at the Met Gala](https://www.harpersbazaar.com/celebrity/red-carpet-dresses/a27382445/lena-waithe-met-gala-2019/); earned an [NAACP Image Award nod](https://naacpimageawards.net/nominees/) for her Showtime drama, _The Chi_; celebrated the release of her first penned feature film, _Queen &amp; Slim_ (directed by Melina Matsoukas, another honoree on this year&#39;s list); inked a [two-year, eight-figure deal with Amazon Studios](https://thegrapevine.theroot.com/lena-waithe-signs-overall-deal-with-amazon-studios-1836771865) to create more must-see content; and signed on with Sight Unseen Pictures to develop opportunities for writers who tell stories about underrepresented people. She&#39;ll be shining onscreen, too—HBO announced that she&#39;ll flex her acting talents in the third season of _Westworld_ next year.",
        "website": "https://hillmangradnetwork.com/team",
        "claimToFame": "The actor-director-writer-producer is booked and busy, with projects spanning the cultural landscape of TV and movies.",
        "influence": 186.2,
        "reach": 14.44,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/lenawaithe/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3JThB8rt4lw5r53KzBDfAk",
        "type": "Entry",
        "createdAt": "2019-09-19T11:52:04.314Z",
        "updatedAt": "2019-09-23T23:54:53.420Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 42,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704276/The%20Root%20100%202019/john.henry.jpg",
        "name": "John Henry",
        "job": "Venture partner, Harlem Capital",
        "sector": "Business",
        "twitterAccount": "JohnHenryStyle",
        "location": "New York City",
        "age": 26,
        "bio": "There are many sides to Henry: the son of blue-collar Dominican immigrants, [a serial entrepreneur,](http://buildwithpassion.com/) [host of Viceland&#39;s show,](https://www.viceland.com/en_us/show/hustle) [_Hustle._](https://www.viceland.com/en_us/show/hustle) He was 18 when [he launched his first business](https://www.forbes.com/sites/forbestreptalks/2016/06/15/he-sold-a-1m-business-at-21-now-hes-helping-harlem-startups-and-podcasting-entrepreneurship-tips/#aa7b63a53385)—an on-demand drycleaning service for New York City film and TV sets—and sold it three years later for nearly $1 million. As part of the four-man team behind Harlem Capital, a New York City-based venture capital firm, he and his partners pooled their initial investment money into a relatively small fund to launch. Each brings a specialty to the table; [Henry&#39;s lane of choice is media relations](https://www.youtube.com/c/JohnHenryStyle) and early-stage business development. Together, they&#39;re laser-focused on [funneling early-stage venture capital funding](https://www.forbes.com/sites/antoinegara/2019/06/24/harlem-capital-tpg-capital-jarrid-tingle-henri-pierre-jacques/#5a328f3e52c2) to 1,000 women and minority-owned businesses over the next 20 years. It&#39;s the support most people of color don&#39;t get from traditional lenders and investors, and that makes Harlem Capital a game changer for black enterprise and a welcome disruptor of the predictable status quo.",
        "website": "http://harlem.capital/team",
        "claimToFame": "Henry is one-fourth of the dynamic Harlem Capital, a venture capital firm that provides start-up funding for black, brown and woman-owned businesses.",
        "influence": 178.2,
        "reach": 10.51,
        "substance": 7.3,
        "instagramUrl": "https://www.instagram.com/johnhenrystyle/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3KHy4mxyewjfCvUhkpjsAu",
        "type": "Entry",
        "createdAt": "2019-09-19T00:04:38.048Z",
        "updatedAt": "2019-09-25T17:21:42.023Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 39,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/brandon.bryant.jpg",
        "name": "Brandon Bryant",
        "job": "Venture partner, Harlem Capital",
        "sector": "Business",
        "twitterAccount": "wallstreetpaper",
        "location": "New York City",
        "age": 28,
        "bio": "One business in four parts—that&#39;s [the formula for success at Harlem Capital](https://www.forbes.com/profile/harlem-capital/?list=30under30-social-entrepreneurs#793741ff8837). Bryant is a venture partner at [the black-owned firm](http://harlem.capital/team), launched by him and three more like-minded, 20-something brothers on an entrepreneurial mission to invest funding into [1,000 minority and woman-owned companies](https://www.theroot.com/meet-the-4-black-men-who-are-shaking-up-the-white-male-1836597048) over the next 20 years. Founders and managing partners Henri Pierre-Jacques and Jarrid Tingle (who are also honorees, as is John Henry) are the respective strategists and analysts, fellow venture partner John Henry is a media specialist, and Bryant is [a brand management and marketing pundit](https://twitter.com/wallstreetpaper/status/974367945743847425) and, in a past life, he was an investment banking analyst at Bank of America Merrill Lynch. And, in his current one, Bryant is also creative director of Wall Street Paper, a lifestyle and culture outlet for style-savvy black men. So far, Harlem Capital has [invested in 17 businesses](https://medium.com/@harlemcapitalpartners/harlem-capital-investment-in-aunt-flows-1-5mm-seed-round-937dd0bb96c1), a fantastic achievement for a firm still in its infancy, and the Cleveland native is building source deals and industry relationships to evangelize the Harlem Capital message on ever-expanding platforms.",
        "website": "http://harlem.capital/",
        "claimToFame": " Bryant is one-fourth of the dynamic Harlem Capital, a venture capital firm that provides startup funding for black, brown and woman-owned businesses.",
        "influence": 174.2,
        "reach": 10.68,
        "substance": 7.3,
        "instagramUrl": "https://www.instagram.com/wallstreetpaper/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3Ti1HGjhVyOqljPqcMKZes",
        "type": "Entry",
        "createdAt": "2019-09-17T23:56:58.335Z",
        "updatedAt": "2019-09-23T23:52:21.353Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 36,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/karine.jean.pierre.jpg",
        "name": "Karine Jean-Pierre",
        "job": "Chief public affairs officer, MoveOn.org",
        "sector": "Politics",
        "twitterAccount": "k_jeanpierre",
        "location": "New York City",
        "age": 42,
        "bio": "We all remember that moment when [a protestor came on stage to grab the mic](https://www.msnbc.com/morning-joe/watch/-i-cannot-let-this-happen-karine-jean-pierre-on-blocking-sen-harris-61230661805) from Sen. Kamala Harris during a political forum. That&#39;s when Karine Jean-Pierre swooped in like a member of Wakanda&#39;s Dora Milaje to keep him at bay. But if you&#39;ve seen Jean-Pierre hold court as [a political analyst on MSNBC](https://thehill.com/homenews/media/424299-nbc-msnbc-hires-moveonorg-executive-as-political-analyst), you know she&#39;s not afraid to speak truth to power about the abuses of the Trump administration. As the chief public affairs officer at MoveOn.org, the former [Obama administration alum](http://www.karinejean-pierre.com/#About) helps the organization further its progressive causes, including getting Donald Trump out of the White House. Her [book](http://www.karinejean-pierre.com/book), _Moving Forward_, will be released in November.",
        "website": "http://www.karinejean-pierre.com/",
        "claimToFame": "The veteran political operative and MSNBC analyst isn&#39;t afraid to speak truth to power about the current administration&#39;s harmful policies.",
        "influence": 178.9,
        "reach": 12.59,
        "substance": 7.1,
        "instagramUrl": "https://www.instagram.com/k_jeanpierre/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "7ztPRh7LLOXxMHFK4MCmf1",
        "type": "Entry",
        "createdAt": "2019-09-19T21:21:29.149Z",
        "updatedAt": "2019-09-24T22:58:25.227Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 77,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704276/The%20Root%20100%202019/lorin.crawford.jpg",
        "name": "Lorin Crawford",
        "job": "Assistant professor of biostatistics at Brown University",
        "sector": "STEM",
        "twitterAccount": "lorin_crawford",
        "location": "Providence, R.I.",
        "age": 28,
        "bio": "[Lorin Crawford](http://www.lcrawlab.com/people.html) is using machine learning to help other scientists better understand genetic disorders. The Clark-Atlanta University grad [teaches biostatistics at Brown University](https://vivo.brown.edu/display/lcrawfo1). His speciality? Developing &quot;efficient computational methodologies to address complex problems in statistical genetics, cancer pharmacology, and radiomics.&quot; A Forbes 30 for 30 honoree, Crawford is one of the [2019 Alfred P. Sloan Jr. Foundation Research Fellows](https://sloan.org/fellowships/2019-Fellows), which honors early-career scholars who &quot;represent the most promising scientific researchers working today,&quot; for his work in computational and evolutionary molecular biology.",
        "website": "http://www.lcrawlab.com/",
        "claimToFame": "An up-and-coming researcher, Crawford is the winner of the 2019 Alfred P. Sloan Jr. foundation's research fellowship for his work developing statistical models to help scientists better understand genetic disorders.",
        "influence": 143.6,
        "reach": 6.51,
        "substance": 7.5
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "tPNBDCW78lWDTAmNCxrAX",
        "type": "Entry",
        "createdAt": "2019-09-17T19:33:29.830Z",
        "updatedAt": "2019-09-25T17:44:48.289Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 99,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/brooke.obie.jpg",
        "name": "Brooke Obie",
        "job": "Managing editor, Shadow & Act",
        "sector": "Media",
        "twitterAccount": "BrookeObie",
        "location": "Los Angeles",
        "age": 33,
        "bio": "[Brooke Obie](http://www.brookeobie.com/about/) loves telling black stories. As the managing editor of black film and TV site Shadow &amp; Act, Obie highlights the narratives of black folks on film and TV from around the African diaspora. So when Hollywood dropped _Green Book_, yet another film in a long line of [white savior films](https://en.wikipedia.org/wiki/White_savior_narrative_in_film#List_of_associated_films), Obie went to work calling the movie out with [a scathing review](https://shadowandact.com/green-book-film-review-white-savior) and an interview with [the family of Dr. Don Shirley](https://shadowandact.com/green-book-is-full-of-lies-dr-don-shirleys-family-speaks-out)—whose story was at the heart of _Green Book_—who said the film was &quot;full of lies.&quot; While the flick received rave reviews and went on to win the Oscar for Best Picture, Obie&#39;s coverage sparked a larger convo about Hollywood&#39;s enduring love of centering whiteness in stories about black people.",
        "website": "http://www.brookeobie.com/",
        "claimToFame": "The managing editor of black film and TV site Shadow & Act sparked a national conversation about _Green Book_, another in a long line of films that centered whiteness at the expense of compelling black stories.",
        "influence": 114.9,
        "reach": 6.18,
        "substance": 6.8,
        "instagramUrl": "https://www.instagram.com/brookeobie/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5Cx2FQOjsyaeqtkq31nGRH",
        "type": "Entry",
        "createdAt": "2019-09-18T00:57:10.101Z",
        "updatedAt": "2019-09-20T18:43:42.099Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 2,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704272/The%20Root%20100%202019/Nipsey.Hussle.jpg",
        "name": "Nipsey Hussle",
        "job": "Rapper, entrepreneur",
        "sector": "Entertainment",
        "twitterAccount": "NipseyHussle",
        "location": "Los Angeles",
        "age": 33,
        "bio": "Nipsey Hussle was on the verge of living up to his self-chosen moniker, &quot;Tha Great,&quot; when his life was tragically cut short on March 31, 2019. In 2018, the South Los Angeles native released his major label debut album, _Victory Lap_, which earned the rapper mainstream recognition and his first Grammy nomination. Born Ermias Joseph Asghedom, Nipsey was much more than a rapper. An avid hustler, Nip co-owned the Marathon Clothing store with his older brother, Samuel Asghedom, in the neighborhood he grew up in. He also he opened [Vector90](https://www.vector90.com/), a co-working space, incubator and cultural hub, along with other businesses that provided jobs and opportunities to help revitalize his community, which he cared about deeply. In August, Nipsey&#39;s family [announced](https://www.instagram.com/p/B0okZVZJmzm/) they were beginning work on Nipsey Hussle Tower, which will sit on the corner of the rapper&#39;s beloved intersection, Slauson and Crenshaw.",
        "website": "https://ihussle.com/",
        "claimToFame": "In addition to dropping hot music, Nipsey was beloved in his community because he worked to revitalize the neighborhood by opening businesses, creating jobs and opportunities. He will be best remembered for his enduring mantra, &quot;The Marathon Continues.&quot;",
        "influence": 247.6,
        "reach": 16.56,
        "substance": 7.8,
        "instagramUrl": "https://www.instagram.com/nipseyhussle/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2yMd5F2iygrjA4nMabpOHd",
        "type": "Entry",
        "createdAt": "2019-09-10T17:53:22.358Z",
        "updatedAt": "2019-09-25T17:16:35.489Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 7,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 3,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704272/The%20Root%20100%202019/lizzo.jpg",
        "name": "Lizzo",
        "job": "Singer, flutist",
        "sector": "Entertainment",
        "twitterAccount": "lizzo",
        "location": "Los Angeles",
        "age": 31,
        "bio": "It&#39;s been the Year of Lizzo (born Melissa Viviane Jefferson), and her signature brand of [carefree black girl](https://www.theroot.com/why-carefree-black-girls-are-here-to-stay-1790876664) has catapulted her into the affections of the adoring mainstream. She [destroyed the stage at Coachella](https://pitchfork.com/news/watch-lizzo-perform-through-sound-problems-at-coachella-2019/)—with technical difficulties—and gave us [creative sets at the BET Awards](https://www.youtube.com/watch?v=hcVOMUrBpF4), [MTV Movie &amp; TV Awards](https://www.youtube.com/watch?v=HKNrYV_jwbc) _and_ the [MTV Video Music Awards](https://theglowup.theroot.com/that-validation-felt-good-as-hell-lizzo-bodied-the-201-1837602000). She made the TV debut of her single, &quot;[Juice](https://www.youtube.com/watch?v=N8ZI1Jlrf-w),&quot; on _Ellen_, complete with her signature twerking and flute solo. [She posed for Playboy](https://www.playboy.com/read/lizzo-the-incomparable), Allure and other publications that, up until this current inclusive moment, would have rejected a plus-size cover girl. Her third album, _Cuz I Love You_,  reached No. 6 on [the Billboard 200 Albums chart](https://www.billboard.com/articles/news/awards/8527426/lizzos-truth-hurts-might-still-qualify-at-2020-grammys) and her single, &quot;Truth Hurts,&quot; topped [the Billboard Hot 100 two years after its release](https://thegrapevine.theroot.com/100-that-billboard-topper-lizzo-scores-no-1-with-tru-1837865751) and is now [the longest-running Billboard Hot 100 No. 1 by a solo female rapper](https://www.billboard.com/articles/columns/hip-hop/8530789/lizzo-reaction-truth-hurts-hot-100-record) (though we do take issue with Billboard calling her a \"rapper\"). Lizzo is a one-woman movement of contagious self-love and a champion for body positivity and people who feel different or unseen. Still, the classically trained flutist remains who she&#39;s always been: delightfully, expressively and completely herself.",
        "website": "https://cuziloveyou.lizzomusic.com/",
        "claimToFame": "The world is finally catching up to Lizzo, whose infectious music and body-positive performances are inspiring us all to love ourselves.",
        "influence": 243.6,
        "reach": 13.12,
        "substance": 8.2,
        "instagramUrl": "https://www.instagram.com/lizzobeeating/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6yOBvaxQY1MNXji7WCSf2e",
        "type": "Entry",
        "createdAt": "2019-09-17T22:15:01.248Z",
        "updatedAt": "2019-09-24T23:12:32.061Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 97,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704276/The%20Root%20100%202019/dorian.burton.jpg",
        "name": "Dorian Burton",
        "job": "Assistant executive director, William R. Kenan Jr. Charitable Trust",
        "sector": "Community",
        "twitterAccount": "dorian_burton",
        "location": "Durham, N.C.",
        "age": 37,
        "bio": "[Dorian Burton](https://dorianburton.com/) believes philanthropy is about more than just giving money to causes—it's about changing lives. As chief program officer and assistant executive director of the [William R. Kenan Jr. Charitable Trust](http://www.kenancharitabletrust.org/), he is using [philanthropy to support social justice movements](https://ssir.org/articles/entry/paying_in_full). Burton has steered the trust toward issues revolving around racial equity like [investing $5 million](https://outline.com/M46CFM) in Kentucky to help black boys and men touched by violence, or [awarding $400,000](http://www.sfltimes.com/news/four-of-miamis-black-male-leaders-awarded-400000) to black men in Florida who&#39;ve displayed strong leadership skills. Burton has been about that life for a minute—a Harvard alum with a Ph.D. in education leadership, Burton is also co-founder of [TandemEd](http://www.tandemed.com/leadership), an org dedicated to improving black male achievement.",
        "website": "https://dorianburton.com/",
        "claimToFame": "An author, speaker and consultant, Burton is reshaping the role that philanthropic organizations can play in bringing about racial equity.",
        "influence": 117.8,
        "reach": 5.76,
        "substance": 7
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "cdZ1pe8VojgYL2M6kjYg9",
        "type": "Entry",
        "createdAt": "2019-09-18T00:51:21.828Z",
        "updatedAt": "2019-09-20T18:53:32.028Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 21,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/nikole.hannah.jones.jpg",
        "name": "Nikole Hannah-Jones",
        "job": "Investigative journalist, The New York Times",
        "sector": "Media",
        "twitterAccount": "nhannahjones",
        "location": "New York City",
        "age": 43,
        "bio": "Her Twitter name is &quot;Ida Bae Wells&quot; and her play on the iconic activist-journalist&#39;s name couldn&#39;t be more appropriate. Hannah-Jones&#39; resonant reportage for the New York Times Magazine stretches across segregation, race, justice and their contemporary contexts, and she covers them with an award-winning badassery and eloquence that affects actual change. This year, the MacArthur &quot;genius&quot; conceptualized the Times&#39; 1619 Project, a body of work commemorating the 400th anniversary of the arrival of the first enslaved Africans in America and the lasting impact it&#39;s had on the country. Hannah-Jones and her editors enlisted the expert talents of black writers, researchers and photographers, and expanded the project into a multipart audio series and a school curriculum co-developed with the Pulitzer Center. That it was spearheaded by a black woman with a history of excellence in journalism and storytelling is another milestone in Hannah-Jones&#39; legacy-making body of work.\n",
        "website": "https://nikolehannahjones.com/",
        "claimToFame": "Hannah-Jones is one of the best journalists to ever do it. This year, she pitched the idea for the New York Times Magazine&#39;s landmark 1619 Project, which commemorates the 400th anniversary of the first enslaved Africans&#39; arrival to America.",
        "influence": 196.2,
        "reach": 9.4,
        "substance": 8
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "Hc0bQb43aujSlFT5ZptVP",
        "type": "Entry",
        "createdAt": "2019-09-19T21:13:12.512Z",
        "updatedAt": "2019-09-24T23:01:04.032Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 81,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704276/The%20Root%20100%202019/lauren.wesley.wilson.jpg",
        "name": "Lauren Wesley Wilson",
        "job": "Founder and CEO of ColorComm, Inc.",
        "sector": "Business",
        "twitterAccount": "lwesleywilson",
        "location": "New York City",
        "age": 33,
        "bio": "Lauren Wesley Wilson wants to help the media reflect the diversity of the world. She&#39;s the founder and CEO of ColorComm, a networking organization for women of color in media and communications. Since the organization [began in 2011](https://www.cosmopolitan.com/career/a57217/lauren-wesley-wilson-color-comm-get-that-life/), ColorComm has grown to thousands of members across the nation. Six years ago, ColorComm launched its [annual conference](https://www.prnewswire.com/news-releases/colorcomm-announces-the-eight-honorees-of-the-2019-colorcomm-circle-awards-300860001.html), which brought together 34 women of color media professionals to connect and network over lunch. This year&#39;s conference brought more than 500 executive leaders in communications, marketing, advertising, and digital. Clearly, Wilson saw the needs of business women of color and had the vision to fulfill them.",
        "website": "http://www.colorcommnetwork.com/",
        "claimToFame": "A communications professional and master networker, Wilson is the founder and CEO of ColorComm, a networking organization for women of color in communications.",
        "influence": 140.1,
        "reach": 8.17,
        "substance": 7.1,
        "instagramUrl": "https://www.instagram.com/laurenwesleywilson/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2mAj9dzIsAdHDORzoqLSYv",
        "type": "Entry",
        "createdAt": "2019-09-18T00:03:51.402Z",
        "updatedAt": "2019-09-18T16:17:29.260Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 41,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/kerby.jean-raymond.jpg",
        "name": "Kerby Jean-Raymond",
        "job": "Founder, Pyer Moss; artistic director, Reebok Studies__",
        "sector": "Business",
        "twitterAccount": "pyermoss",
        "location": "New York City",
        "age": 32,
        "bio": "Since launching Pyer Moss in 2013, Kerby Jean-Raymond has been delivering more than just fashion. [According to Vogue](https://www.vogue.com/article/vogue-forces-of-fashion-2019-kerby-jean-raymond-pyer-moss), the Haitian-American designer takes a &quot;socially conscious approach to the runway,&quot; focusing on the challenges and triumphs of black people in America. After inking a deal with Reebok in 2017, Jean-Raymond [was recently named artistic director of Rebook Studies\\_\\_](https://theglowup.theroot.com/giant-steps-pyer-moss-designer-kerby-jean-raymond-earn-1836871931), a new division that will focus on developing new talent and ideas. Jean-Raymond won the prestigious 2019 [CFDA/Vogue Fashion Fund award](https://cfda.com/news/breaking-news-kerby-jean-raymond-of-pyer-moss-wins-15th-cfda-vogue-fashion-fund) and reinvested the $400,000 prize back into his business.",
        "website": "https://pyermoss.com/",
        "claimToFame": "The award-winning designer was recently named the artistic director of Reebok Studies\\_\\_\\_, a new division of the sportswear giant that will focus on developing young, diverse talent with new ideas.",
        "influence": 173.2,
        "reach": 11.16,
        "substance": 7.2,
        "instagramUrl": "https://www.instagram.com/pyermoss/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "gl39DCA8dRrfFRzL73FFs",
        "type": "Entry",
        "createdAt": "2019-09-07T18:20:25.642Z",
        "updatedAt": "2019-09-25T17:18:03.096Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 18,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568650817/beyonce_retouch_fjej6c.jpg",
        "name": "Beyoncé Knowles-Carter",
        "job": "Entertainer, entrepreneur",
        "sector": "Entertainment",
        "twitterAccount": "beyonce",
        "location": "Los Angeles",
        "age": 38,
        "bio": "It&#39;s officially been 20 years since [_The Writing&#39;s on the Wall_](https://www.youtube.com/watch?v=VpQFtG_f93s), catapulted Destiny&#39;s Child into [otherworldly celebrity](https://www.vice.com/en_us/article/a3xxme/destinys-childs-the-writings-on-the-wall-20th-anniversary-kandi-burruss) and elevated young Beyoncé to become…well, Beyoncé. Nearly every year since, she&#39;s layered on more greatness, reinventing herself over and over again as not just the most extraordinary entertainer of our generation, but a gifted entrepreneur who&#39;s building her brand into a multifaceted business. [_Homecoming_](https://www.youtube.com/watch?v=fB8qvx0HOlI) has been her biggest deal yet. Not only was her Coachella performance itself an uncut and undiluted celebration of black culture, she brokered its airing into [an exclusive $60 million, three-project deal with Netflix](https://www.indiewire.com/2019/04/beyonce-netflix-homecoming-black-women-1202126833/). The documentary earned [six Emmy nominations](https://deadline.com/2019/07/beyonce-emmy-nominations-homecoming-netflix-film-1202647185/), a personal best for Bey, who got four nods for her visual album, _Lemonade_, in 2016. There&#39;s also [Oscar buzz around her](https://nypost.com/2019/07/18/could-beyonce-finally-win-coveted-oscar-with-lion-king-song/) for the song, &quot;Spirit,&quot; which she produced to complement [the live-action remake of](https://thegrapevine.theroot.com/july-2019-beyonce-is-coming-to-pride-rock-in-lion-king-1830613926) [_The Lion King_](https://thegrapevine.theroot.com/july-2019-beyonce-is-coming-to-pride-rock-in-lion-king-1830613926)_,_ which she also starred in.",
        "website": "http://www.beyonce.com/",
        "claimToFame": "It&#39;s been another charmed year of hard work and living out dreams for the multihyphenate star, who forged a megadeal with Netflix for _Homecoming_ and starred in Disney&#39;s remake of _The Lion King_.",
        "influence": 200,
        "reach": 18.72,
        "substance": 6.8,
        "instagramUrl": "https://www.instagram.com/beyonce/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2PIy53hLz9aLBwYTlyazjk",
        "type": "Entry",
        "createdAt": "2019-09-10T17:19:01.456Z",
        "updatedAt": "2019-09-24T00:01:48.175Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 46,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/Lauren.Underwood.jpg",
        "name": "Lauren Underwood",
        "job": "U.S. Representative, Illinois",
        "sector": "Politics",
        "twitterAccount": "RepUnderwood",
        "location": "Naperville, Ill., and Washington, D.C.",
        "age": 32,
        "bio": "\nUnderwood&#39;s election in November 2018 made her an [instant history-maker](https://underwood.house.gov/about): the first woman, the first person of color and the first millennial to represent her Illinois district in the House and the youngest black woman to ever serve in Congress. Oh, and she did it by defeating a four-term Republican incumbent. A registered nurse who was previously appointed by the Obama administration [to help dismantle public health crises](https://www.underwoodforcongress.com/facts/), she&#39;s been on fire, sponsoring or co-sponsoring 142 bills on everything from [healthcare affordability to homeland security](https://www.congress.gov/member/lauren-underwood/U000040?q=%7B%22sponsorship%22%3A%22sponsored%22%7D). Her signature order of business has been an especially critical one: [the development of the Black Maternal Health Caucus](https://theglowup.theroot.com/black-mothers-matter-reps-alma-adams-and-lauren-under-1833914278), formed along with Rep. Alma Adams (D-N.C.) in partnership with the Black Mamas Matter Alliance, to prioritize health outcomes and slash mortality rates for black women and babies. Underwood, who serves as co-chair of the caucus with Adams, uses social media to broadcast its urgency and, in July, she made the caucus&#39; first summit a gathering of people who are about finding and facilitating solutions.",
        "website": "https://underwood.house.gov/",
        "claimToFame": "Rep. Underwood co-founded the Black Maternal Health Caucus to elevate lifesaving healthcare for black women and infants.\n",
        "influence": 170.5,
        "reach": 12.11,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/repunderwood/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5C3QhaA3EV28zMFQoCJMjP",
        "type": "Entry",
        "createdAt": "2019-09-17T19:05:19.206Z",
        "updatedAt": "2019-09-18T16:20:40.208Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 54,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704276/The%20Root%20100%202019/arlan.hamilton.jpg",
        "name": "Arlan Hamilton",
        "job": "Founder, Backstage Capital",
        "sector": "STEM",
        "twitterAccount": "ArlanWasHere",
        "location": "Los Angeles",
        "age": 38,
        "bio": "After being frustrated by the lack of venture funding for startups helmed by women and people of color, Arlan Hamilton founded Backstage Capital to help tech innovators from underrepresented communities get access to much-needed investment. According to Hamilton, the company has invested in over 125 startups led by women, people of color and LGBTQ+ founders since 2015. Last year, Hamilton established [a $36 million fund](https://www.forbes.com/) to exclusively invest in black female founders. This year, Hamilton helped maternal health tech company Mahmee [raise $3 million](https://www.forbes.com/sites/estrellajaramillo/2019/07/15/mahmee-raises-3m-serena-williams-mark-cuban-to-disrupt-prenatal-and-postpartum-care/#4780a16a5d1a) from investors like Serena Williams and Mark Cuban. Hamilton, [who was homeless when she launched Backstage Capital](https://www.latimes.com/business/la-fi-himi-arlan-hamilton-backstage-capital-20190512-story.html), has proven she has the vision to see promise in places that the tech bros do not.",
        "website": "https://backstagecapital.com",
        "claimToFame": "The Backstage Capital founder has a gift for spotting the potential of startups led by women, people color and members of the LGBTQ community, and has helped over 125 startups get funding.",
        "influence": 166.4,
        "reach": 11.54,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/arlanwashere/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2D8nPAg6ZKAYe0cvTVXW3y",
        "type": "Entry",
        "createdAt": "2019-09-19T20:49:54.783Z",
        "updatedAt": "2019-09-23T23:28:59.597Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 20,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/janelle.monae.jpg",
        "name": "Janelle Monáe",
        "job": "Singer, actor, activist",
        "sector": "Entertainment",
        "twitterAccount": "JanelleMonae",
        "location": "Atlanta",
        "age": 33,
        "bio": "What _can&#39;t_ Janelle Monáe do? _The Dirty Computer_ performer can [sing, act, tear up the stage and run Wondaland Records](https://www.fastcompany.com/90263428/how-singer-songwriter-actress-activist-janelle-monae-gets-so-much-done) all without seemingly breaking a sweat. But Monáe didn&#39;t get to the top by chance. She takes her time, picking the right people and projects, like her first film role in 2016&#39;s Oscar-winning film, _Moonlight_. Up next: She appears in _Harriet,_ the big-screen biopic about Harriet Tubman, and she&#39;s starring in the new season of the critically acclaimed series, [_Homecoming_](https://www.rollingstone.com/music/music-news/janelle-monae-homecoming-season-2-862555/).  While she could focus 100 percent of her energy on her career, Monáe gives back to worthy causes, like partnering with forever first lady Michelle Obama&#39;s organization, [When We All Vote](https://www.spelman.edu/about-us/news-and-events/news-releases/2018/09/05/when-we-all-vote).",
        "website": "https://www.jmonae.com/",
        "claimToFame": "The Grammy-nominated star has broken the mold in almost every way possible. Up next: She is set to appear in the biopic _Harriet_, and the new season of the acclaimed Amazon Prime series, _Homecoming_.",
        "influence": 199,
        "reach": 16.5,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/janellemonae/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3JVxtGeHXX4mwwuMerhlXS",
        "type": "Entry",
        "createdAt": "2019-09-19T14:21:18.039Z",
        "updatedAt": "2019-09-25T17:42:19.410Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 92,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/naomi.washington-leapheart.jpg",
        "name": "Naomi Washington-Leapheart",
        "job": "Faith work director, National LGBTQ Task Force",
        "sector": "Community",
        "twitterAccount": "oholyshift",
        "location": "Philadelphia",
        "age": 37,
        "bio": "Washington-Leapheart is one of the future-forward leaders scrubbing churches of the conservative cultures that make LGTBQ inclusion and same-sex marriage divisive issues. She&#39;s dexterous, as comfortable in the pulpit as she is in the streets, and her work as an advocate [dismantles archaic traditions and beliefs](http://www.philadelphiaweekly.com/news/lgbt-clergy-representing-the-new-face-of-faith-speak-out/article_4e51792a-5a22-11e9-be32-cbb474fcc359.html) to make houses of worship safe, welcoming places for gay, queer and trans people. As faith work director for the National LGBTQ Task Force, the ordained minister engages congregation leaders to get their support for LGBTQ initiatives and helps them prioritize the community&#39;s spiritual needs, not just tolerate them. At Villanova University, where she is an adjunct professor of theology and religious studies, Washington-Leapheart earned the 2019 Pohlhaus-Stracciolini Award for Teaching Excellence for her challenging instruction on faith, reason and culture in the classroom and her community activism outside of it.",
        "claimToFame": "Washington-Leapheart is creating the shift in church culture that welcomes the LGBTQ community and creates spaces where gay, queer and trans people can fully see themselves as part of God&#39;s image.",
        "influence": 128.7,
        "reach": 5.83,
        "substance": 7.3
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5P0idsdm0uliErvB1580ar",
        "type": "Entry",
        "createdAt": "2019-09-19T15:43:15.953Z",
        "updatedAt": "2019-09-23T23:32:08.899Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 22,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/steph.curry.jpg",
        "name": "Stephen Curry",
        "job": "NBA player, entrepreneur",
        "sector": "Sports",
        "twitterAccount": "StephenCurry30",
        "location": "Atherton, Calif.",
        "age": 31,
        "bio": "The Golden State Warriors didn&#39;t win the NBA championship this year, but Curry and company made [their fifth appearance in the finals in five years](https://in.nba.com/news/nba-finals-2019-history-of-golden-state-warriors-stephen-curry-finals/143u510hgx0gn1l7z86foxndb2), the second-longest streak for a team in league history. The superstar, who&#39;s also an avid golfer, is an all-around sportsman _and_ an all-around philanthropist. Thanks to his deep pockets and love for the sport, Howard University has [its first men&#39;s and women&#39;s golf program](https://dcist.com/story/19/08/19/howard-university-has-a-golf-team-again-thanks-to-a-major-assist-from-steph-curry/) since the HBCU abandoned the golf program in the '70s. Curry is sponsoring both Division I teams for their initial six years to make Howard the 34th HBCU to have a golf program and literally equalize the playing field by giving black students access to the business networking and dealing white folks have been doing on the course for years. On another entertainment front, the two-time NBA MVP racked up executive producer credits for _Emanuel_, [the award-winning documentary](https://www.emanuelmovie.com/) that honors the nine victims of the South Carolina church shooting and tells the post-tragedy stories of its survivors.",
        "claimToFame": "Curry bankrolled Howard University&#39;s new golf program and executive produced _Emanuel_, a documentary about the Charleston, S.C., church shooting, helping him build an off-court legacy as meaningful as the one he&#39;s established on it.",
        "influence": 193.4,
        "reach": 18.56,
        "substance": 6.7,
        "instagramUrl": "https://www.instagram.com/stephencurry30/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3Q4FTG2nTqvS78O6sdIbRg",
        "type": "Entry",
        "createdAt": "2019-09-19T22:08:32.403Z",
        "updatedAt": "2019-09-20T12:35:54.119Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 76,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/wayman.bannerman.jpg",
        "name": "Wayman Bannerman",
        "job": "Stylist",
        "sector": "Entertainment",
        "location": "Los Angeles",
        "age": 36,
        "bio": "[Acclaimed Hollywood stylist Wayman Bannerman](https://theglowup.theroot.com/it-takes-a-very-stylish-village-thr-celebrates-the-s-1833280482) always knew he wanted to live a creative life. After graduating from the Fashion Institute of Technology, Bannerman [worked in several positions across the industry](https://www.waymanandmicah.com/about-1/), including marketing and editorial for brands like Henri Bendel, L&#39;Officiel, GQ and The New York Times. Eventually, he teamed up with his friend and fellow stylist, Micah McDonald, to found Wayman + Micah, who were named [two of the most powerful stylists in Hollywood by The Hollywood Reporter](https://www.hollywoodreporter.com/lists/25-top-stylists-hollywood-2018-1093944).",
        "website": "https://www.waymanandmicah.com/",
        "claimToFame": "Along with his partner, Micah McDonald, Bannerman was named one of the most powerful stylists in Hollywood.",
        "influence": 143.6,
        "reach": 6.52,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/waydb/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "10vUZMbN2zeWCCLPh5CSEz",
        "type": "Entry",
        "createdAt": "2019-09-17T22:08:43.811Z",
        "updatedAt": "2019-09-24T23:03:19.297Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 88,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/diamond.stingily.jpg",
        "name": "Diamond Stingily",
        "job": "Artist, poet",
        "sector": "Arts",
        "twitterAccount": "lilboosieplaycz",
        "location": " New York City",
        "age": 29,
        "bio": "[The world definitely needs more artists](https://i-d.vice.com/en_uk/article/gyw7nb/the-world-needs-more-artists-like-diamond-stingily) like Diamond Stingily. A poet and artist, Stingily interrogates issues of [racism, sexism, surveillance, and relationships](https://i-d.vice.com/en_uk/article/gyw7nb/the-world-needs-more-artists-like-diamond-stingily) in her work, which consists of audio, videos, sculptures and installations. Stingily&#39;s art has been shown in [numerous galleries](http://lvl3official.com/diamond-stingily/) around the world, including Ramiken Crucible, Queer Thoughts, The New Museum, Institute of Contemporary Art Miami, and the Wattis Institute. In April, the New York Times declared her one of &quot;[Four Artists to Watch Now](https://www.nytimes.com/2019/04/25/arts/design/artists-to-watch-galleries.html).&quot;",
        "claimToFame": "Thanks to her groundbreaking work, the New York Times declared Stingily one of &quot;Four Artists to Watch Now.&quot;",
        "influence": 135.4,
        "reach": 7.64,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/lilboosieplaycousin/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "46A46w4fMynEBPc2Nf0ms6",
        "type": "Entry",
        "createdAt": "2019-09-19T21:38:03.501Z",
        "updatedAt": "2019-09-20T12:38:57.734Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 95,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/Raniyah.Copeland.jpg",
        "name": "Raniyah Copeland",
        "job": "President and CEO of the Black AIDS Institute",
        "sector": "Community",
        "twitterAccount": "raniyah143",
        "location": "Los Angeles",
        "age": 34,
        "bio": "When Phil Wilson [decided to retire](https://aumag.org/2019/01/04/cover-story-phill-wilson-raniyah-copeland/) as the president of [the Black AIDS Institute](https://blackaids.org/raniyah-copeland/), an organization he founded in 1999, he knew the think tank was in good hands. Wilson said his successor, Raniyah Copeland, was &quot;[beautiful, bold, brave, and brilliant](https://www.losangelesblade.com/2018/12/29/phill-wilson-says-goodbye-to-the-black-aids-institute-he-founded-photos/).&quot; A graduate of U.C. Berkeley, Copeland worked her way up through the ranks at BAI, serving as the group&#39;s training and capacity building coordinator, manager, and director of programs before taking the reins in 2019. Copeland is also the [co-founder](https://aumag.org/2019/01/04/cover-story-phill-wilson-raniyah-copeland/) of the [Afrikan Black Coalition,](http://afrikanblackcoalition.org/) a statewide organization for black students in California.",
        "website": "https://blackaids.org/",
        "claimToFame": "Copeland is the new president and CEO of the Black AIDS Institute.",
        "influence": 120.5,
        "reach": 6.05,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/blackaids/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2ZLzPwddnZMP06UN5i2STy",
        "type": "Entry",
        "createdAt": "2019-09-19T14:07:34.423Z",
        "updatedAt": "2019-09-20T12:43:09.074Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 85,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/meghan.markle.jpg",
        "name": "Meghan Markle",
        "job": "Duchess of Sussex",
        "sector": "Community",
        "location": "Sussex, England",
        "age": 38,
        "bio": "When she married into the royal family, Markle instantly became one of the most famous black women in the world and as such, the public has rained criticism upon her as part of an ongoing campaign of elitism, scrutiny and prejudice. Prince Harry calls it &quot;[unconscious bias](https://www.harpersbazaar.com/celebrity/latest/a28550589/prince-harry-unconscious-racism-jane-goodall/).&quot; Her friend [Jameela Jamil flat-out calls it racism](https://www.latimes.com/entertainment-arts/story/2019-08-21/jameela-jamil-meghan-markle-racism-prince-harry). In the thick of it, whatever &quot;it&quot; is, Markle has maintained an unflappable sweetness, humility and grace, and [kept her energy focused](https://www.instyle.com/news/meghan-markle-renews-the-tig-trademark) on the influences her new platforms have on her advocacy for women, children and disadvantaged people, along with higher education, animals and the arts. The new mom even found opportunities to extend acts of selflessness when she and Prince Harry, who broke a Guinness World Record with [their new Instagram account](https://www.guinnessworldrecords.com/news/2019/4/prince-harry-and-meghan-markles-instagram-account-breaks-record-within-six-hours-567631), asked fans and friends to [donate to a list of favorite charities](https://www.elle.com/culture/celebrities/a27056727/meghan-markle-prince-harry-donate-baby-shower-gifts/) in lieu of sending baby shower gifts for their first child, Archie.\n",
        "claimToFame": "Markle, who has faced a racist backlash, is the epitome of royal dignity and class as she continues to settle into her role as the Duchess of Sussex and new mom with the birth of her first child, Archie.",
        "influence": 138.7,
        "reach": 8.01,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/sussexroyal/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2q3tySGi7JTqq6dAH0l15R",
        "type": "Entry",
        "createdAt": "2019-09-10T18:11:01.870Z",
        "updatedAt": "2019-09-20T21:46:35.061Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 50,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/Mashama.Bailey.jpg",
        "name": "Mashama Bailey",
        "job": "Executive chef, restaurateur",
        "sector": "Business",
        "location": "Savannah, Ga.",
        "age": 45,
        "bio": "The New York Times calls Bailey one of the [16 black chefs changing food in America](https://www.nytimes.com/interactive/2019/07/16/dining/black-chefs-restaurants-food.html?smid=ig-nytcooking&amp;utm_source=curalate_like2buy&amp;utm_medium=curalate_like2buy_gnauQ5q1__216165fc-7675-47a4-aff1-6793cc48295f&amp;crl8_id=216165fc-7675-47a4-aff1-6793cc48295f). She learned the art of cooking with soul as a kid spending summers in Georgia with her maternal grandmother and, after years of serving delicious dishes from kitchens throughout her native New York City, [she opened The Grey](https://www.instagram.com/thegreysavannah/?hl=en) in a renovated 1930s Greyhound bus depot with business partner John Morisano. As executive chef, Bailey&#39;s menu is a delectable blend of contemporary Southern dishes with Italian influences, earning [Eater&#39;s lofty distinction of Restaurant of the Year](https://www.eater.com/2017/11/8/16620892/the-grey-restaurant-of-the-year). In 2018, the Institute of Culinary Education alumna was a finalist for the Best Chef: Southeast Award from the James Beard Foundation, the equivalent of the Oscars in the world of food. This year, [she won](https://www.savannahnow.com/news/20190507/mashama-bailey-of-savannahs-grey-awarded-2019-james-beard-award-for-best-southeast-chef/1), becoming only the second woman of color to receive the honor in the award&#39;s 28-year history.",
        "website": "http://thegreyrestaurant.com/",
        "claimToFame": "Bailey interprets her cultural heritage through her exquisite culinary skills and this year, she earned the prestigious James Beard Award for best chef in the Southeast.",
        "influence": 168.7,
        "reach": 9.49,
        "substance": 7.4,
        "instagramUrl": "https://www.instagram.com/mashamabailey/?hl=ur"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "62WlglicvjqiItAsoviRJl",
        "type": "Entry",
        "createdAt": "2019-09-19T00:19:32.713Z",
        "updatedAt": "2019-09-20T19:18:02.251Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 96,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704274/The%20Root%20100%202019/delano.dunn.jpg",
        "name": "Delano Dunn",
        "job": "Visual artist",
        "sector": "Arts",
        "twitterAccount": "delano_dunn",
        "location": "Chicago",
        "age": 41,
        "bio": "Dunn was only 13 years old when Los Angeles erupted in rage in 1992 following the acquittal of the four police officers who viciously beat Rodney King. He recalls watching his city literally on fire and the frenzy of activity in his neighborhood, and it&#39;s the inspiration for &quot;[Make the Moment Feel Just Right](https://www.artsy.net/artwork/delano-dunn-make-the-moment-feel-just-right),&quot; the mixed-media collection the [Pratt Institute-trained painter and collagist](http://www.delanodunn.com/) created from his well of memories about that six-day uprising. It&#39;s a period that&#39;s been swallowed into the long history of assaults against the physical bodies and protective rights of black people, but Dunn has never forgotten. This year, the New York Times spotlighted him as [an artist to watch now](https://www.nytimes.com/2019/04/25/arts/design/artists-to-watch-galleries.html) and in his layered compositions, the teaching fellow at the School of the Art Institute of Chicago puts paper, acrylic paint, glitter, shoe polish and resin to use as part of his larger storytelling on race and perspective.",
        "website": "http://www.delanodunn.com",
        "claimToFame": "The New York Times named Dunn an &quot;artist to watch now&quot; for how he conjures his memories from the 1992 Los Angeles riots to create a stunning, mixed-media art collection.",
        "influence": 119.3,
        "reach": 5.93,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/delanodunn/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6jxQxw7q4rDereyBFCEWZa",
        "type": "Entry",
        "createdAt": "2019-09-10T14:00:55.643Z",
        "updatedAt": "2019-09-24T16:32:02.619Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 12,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/crystal.dunn2.jpg",
        "name": "Crystal Dunn",
        "job": "Soccer star",
        "sector": "Sports",
        "twitterAccount": "crysdunn_19",
        "location": "North Carolina",
        "age": 27,
        "bio": "This year, the U.S. Women&#39;s National Team became the first ever to win four World Cup titles. It was an electric championship run they couldn&#39;t have clenched without Queens, N.Y.-born, Long Island-raised Crystal Dunn, a superstar of talent and versatility in any position she plays, from midfield to defender. The 5-foot, 1-inch powerhouse and 2016 Olympian, who also plays forward for the North Carolina Courage, helped lead the team to victory over England, France and a final showdown with the Netherlands. Her play [against France](https://slate.com/culture/2019/06/uswnt-france-crystal-dunn-defense-womens-world-cup.html) was particularly stunning, since being a defender is not her natural role. The win is even more amazing when you consider Dunn&#39;s remarkable rebound—just four years ago, she wasn&#39;t selected to compete for the World Cup despite being named the youngest MVP in [National Women's Soccer League history](https://equalizersoccer.com/2015/09/23/crystal-dunn-2015-nwsl-mvp-washington-spirit/). Off the field, the role model and glowing newlywed speaks out against the [pay disparity](https://theundefeated.com/features/soccer-star-crystal-dunn-on-pay-disparity-the-pressure-to-succeed-and-her-fave-drake/) for women in professional soccer and works to get more black Americans interested and involved in the sport she loves.",
        "website": "http://crystaldunnsoccer.com/",
        "claimToFame": "Dunn is a soccer superstar who helped the U.S. Women&#39;s National Team win this year&#39;s World Cup and become the first team to take it home four times.",
        "influence": 204.4,
        "reach": 13.93,
        "substance": 7.4,
        "instagramUrl": "https://www.instagram.com/cdunn19/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2Gh82Lu7aWu1FlpzmNGSYm",
        "type": "Entry",
        "createdAt": "2019-09-17T22:35:07.377Z",
        "updatedAt": "2019-09-20T19:03:31.998Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 31,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704272/The%20Root%20100%202019/glory.edim.jpg",
        "name": "Glory Edim",
        "job": "Founder, Well-Read Black Girl",
        "sector": "Arts",
        "twitterAccount": "guidetoglo",
        "location": "New York City",
        "age": 36,
        "bio": "It all started with [a T-shirt](https://www.nytimes.com/2018/10/25/books/well-read-black-girl-glory-edim.html). For her 31st birthday, Glory Edim&#39;s boyfriend had a shirt made that said &quot;Well-Read Black Girl,&quot; an ode to Edim&#39;s love of books. Just a few years later, that declaration would become the name of Edim&#39;s popular online book club, and subsequent movement, which highlights and celebrates books by black women. In 2018, Edim released [_Well-Read Black Girl: Finding Our Stories, Discovering Ourselves_](https://www.amazon.com/Well-Read-Black-Girl-Discovering-Ourselves/dp/0525619771), featuring essays from Tayari Jones, Jesmyn Ward and Gabourey Sidibe.",
        "website": "https://www.wellreadblackgirl.com/",
        "claimToFame": "Edim is a book lover, editor and the founder of Well-Read Black Girl, an online book club that&#39;s dedicated to &quot;uplifting the narratives of black women.&quot;",
        "influence": 182.1,
        "reach": 10.48,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/guidetoglo/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5fhUavkeoS0QcChSmgcZ9Z",
        "type": "Entry",
        "createdAt": "2019-09-19T21:57:37.902Z",
        "updatedAt": "2019-09-20T12:37:47.888Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 53,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704271/The%20Root%20100%202019/tanisha.ford.jpg",
        "name": "Tanisha C. Ford",
        "job": "Writer, cultural critic, historian",
        "sector": "Arts",
        "twitterAccount": "soulistaphd",
        "location": "New York City",
        "age": 40,
        "bio": "[Tanisha C. Ford](http://www.tanishacford.com/) didn&#39;t want to be pigeonholed as &quot;the fashion lady&quot; after having written two books on the topic, but she penned her most recent book, [_Dressed in Dreams: A Black Girl&#39;s Love Letter to the Power of Fashion_](https://www.amazon.com/Dressed-Dreams-Black-Letter-Fashion-ebook/dp/B07J4N2XV6/ref=sr_1_1?ascsubtag=73908ede9ea0718471134a7031b1334fef479e89&amp;crid=22XSX09KVG8YF&amp;keywords=dressed%20in%20dreams&amp;qid=1562079282&amp;s=gateway&amp;sprefix=dressed%20in%20%2Caps%2C152&amp;sr=8-1&amp;tag=kinjaroot-20), because she _had_ to document the story of how black womanhood informs style. &quot;So much of our material culture was never deposited in any kind of archive. So, there are so many of our stories around getting dressed, around our clothes and what they mean that never end up in someone&#39;s archive, or even in someone&#39;s museum,&quot; [she told The Root](https://theglowup.theroot.com/dressed-in-dreams-tanisha-c-ford-writes-a-love-letter-1835920576). The historian and cultural critic also co-authored [_Black Is Beautiful_](https://www.amazon.com/Kwame-Brathwaite-Beautiful-Tanisha-Ford/dp/159711443X/ref=sr_1_1?ie=UTF8&amp;qid=1550542785&amp;sr=8-1&amp;keywords=kwame+brathwaite+black+is+beautiful)_,_ a retrospective monograph of Black Arts Movement fashion photographer [Kwame Brathwaite](https://theglowup.theroot.com/throwback-thursday-do-you-know-the-legendary-black-pho-1835118563), who inspired Rihanna&#39;s debut Fenty campaign. For Ford, fashion isn&#39;t just about how we look—she knows that what we wear is both personal and political.",
        "website": "http://www.tanishacford.com/",
        "claimToFame": "The writer, cultural critic and historian captures the personal and the political of black womanhood and fashion in her latest work, _Dressed in Dreams: A Black Girl&#39;s Love Letter to the Power of Fashion_.",
        "influence": 166.4,
        "reach": 8.76,
        "substance": 7.5
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2jVlcbdKiVJfweQHcaiQNf",
        "type": "Entry",
        "createdAt": "2019-09-19T14:39:28.257Z",
        "updatedAt": "2019-09-25T12:41:03.489Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 32,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/ritchie.torres.jpg",
        "name": "Ritchie Torres",
        "job": "Councilman, congressional candidate",
        "sector": "Politics",
        "twitterAccount": "RitchieTorres",
        "location": "New York City",
        "age": 31,
        "bio": "The race for an open congressional seat to represent the Bronx, N.Y., is such a symbolic political contest, the details read like a list of opposites. Torres is a 31-year-old city councilman, [the youngest elected official and first openly LGBTQ person elected](https://www.nytimes.com/2019/07/15/nyregion/torres-diaz-bronx-congress.html) in the Bronx. His colleague and primary opponent, Rubén Díaz Sr., is a 76-year-old Pentecostal minister who still proselytizes that homosexuality is a sin. Both are Afro-Puerto Ricans, which is just about their only shared similarity. It&#39;s the new guard versus the old trope, and Torres is in it to win. He&#39;s called out Díaz&#39;s track record of homophobia and, at the same time, [advocated for LGBTQ resources and rights](https://www.newyorker.com/news/daily-comment/ritchie-torres-another-young-bronx-progressive-launches-a-run-for-congress), including the first shelter for unhoused LGBTQ people in the Bronx and funding for LGBTQ senior centers in all five boroughs. [A product of the Bronx projects](https://twitter.com/ritchietorres/status/1150714820590800897?lang=en), Torres calls himself a &quot;national champion for the urban poor,&quot; working to fix the public housing crisis in the city.",
        "website": "https://council.nyc.gov/district-15/",
        "claimToFame": "Torres is doing more than talking about being the best candidate for an open congressional seat in New York City. He&#39;s showing it by fighting for LGBTQ and low-income people, seniors and the homeless population.",
        "influence": 181.9,
        "reach": 10.45,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/ritchietorresny15/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1BC41C3W3XsTXAx8nvYzgh",
        "type": "Entry",
        "createdAt": "2019-09-10T15:57:09.961Z",
        "updatedAt": "2019-09-24T22:18:09.547Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 52,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/kawhi.leonard2.jpg",
        "name": "Kawhi Leonard",
        "job": "NBA player",
        "sector": "Sports",
        "twitterAccount": "kawhileonard",
        "location": "Los Angeles",
        "age": 28,
        "bio": "When the 2019 NBA Finals narrowed to a showdown between the reigning [Golden State Warriors and the Toronto Raptors](https://www.nba.com/playoffs/2019/finals#/), Leonard unleashed on the competition, averaging 28.5 points per game to lead the Canadian underdogs to a 4-2 series win. And [in a near-unanimous vote](https://ftw.usatoday.com/2019/06/nba-finals-raptors-win-kawhi-leonard-mvp-voting-fred-vanvleet), the superstar forward was named the Finals MVP. The victories were doubly historic—it was the first championship for the Raptors, who put up a 114-110 win against the two-time defending champs in Game 6, and it made Leonard the first NBA player to be named most valuable player with a team from each conference (he earned his first Finals MVP in 2014 as a member of the Western Conference's San Antonio Spurs). Weeks later, in spite of incentives, including an invitation to live in [a multimillion-dollar penthouse](https://sports.yahoo.com/real-estate-investor-offers-kawhi-leonard-free-penthouse-to-stay-with-raptors-191610865.html) for free, Leonard left the Raptors for the Los Angeles Clippers, surprising everyone by turning down a four-year, $142 million max contract in favor of a three-year, $103 million deal that gave him more agency and control of his career destiny.",
        "claimToFame": "The NBA superstar, who recently joined the Los Angeles Clippers, was named MVP of the 2019 NBA Finals, helping the Toronto Raptors win their first championship.",
        "influence": 167,
        "reach": 12.61,
        "substance": 7
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6AI9r0ZBgxwg3qmsB95Wqc",
        "type": "Entry",
        "createdAt": "2019-09-18T00:14:54.885Z",
        "updatedAt": "2019-09-25T17:43:04.718Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 94,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/kiki.ayers.jpg",
        "name": "Kiki Ayers",
        "job": "Publicist",
        "sector": "Business",
        "twitterAccount": "kikiayers",
        "location": "Los Angeles",
        "age": 29,
        "bio": "Ayers&#39; massive success as a young entrepreneur and publicist in the competitive and often cutthroat arena of black Hollywood is even more amazing when you consider that she&#39;s been homeless not once, but twice. When she was 16, the Howard University grad [lived in a car with her mom and siblings](https://www.forbes.com/sites/meimeifox/2018/02/25/from-homeless-to-celebrity-pr-agent-in-just-two-years-the-kiki-ayers-story/#3abeb37422a4) and went on to become the first person in her family to go to college. She taught herself how to draft press releases and get media coverage for celebrities, and in 2016—what she calls her hardest year ever—she [ended up homeless again](https://www.blackenterprise.com/homeless-publicist-kiki-ayers/). But within a year, [she founded Ayers Publicity](http://ayerspublicity.com/the-founder/) and was planning events for the black A-list including Sean Combs, Floyd Mayweather, Jamie Foxx and Snoop Dogg. This year, the enterprising single mom launched [Kopy Kats, a parent-and-child ready-to-wear line](http://kopykatsinc.com/). ",
        "website": "http://ayerspublicity.com",
        "claimToFame": "A champion overcomer, Ayers bested homelessness twice to become one of the top black publicists in the country.",
        "influence": 122.2,
        "reach": 7.41,
        "substance": 6.7,
        "instagramUrl": "https://www.instagram.com/kikiayers/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "4G3xCWot9ZDIQTVar15pNb",
        "type": "Entry",
        "createdAt": "2019-09-17T22:50:31.595Z",
        "updatedAt": "2019-09-20T21:43:21.519Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 19,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/jackie.aina.jpg",
        "name": "Jackie Aina",
        "job": "Beauty expert, advocate",
        "sector": "Community",
        "location": "Los Angeles",
        "age": 32,
        "bio": "With a magnetic personality and skin glazed by the gods of smooth complexions, Aina is both a beauty and a beauty influencer who&#39;s turned her name and knowledge into an international brand. Her [YouTube channel](https://www.youtube.com/channel/UCzJIliq68IHSn-Kwgjeg2AQ) is a video Bible for more than 3 million face-beat devotees, where she deconstructs beauty standards like colorism as she shows her largely black girl fanbase how to feel and look like their best possible selves. On and offline, Aina champions diversity and inclusion across the beauty industry, holding brands accountable to make their products pop on darker skin tones and demanding makeup representation for melanated complexions. [The Army reservist-turned-makeup artist](https://www.defense.gov/explore/story/Article/1794833/army-reservist-to-beauty-activist/)-turned digital glam evangelist worked with Too Faced to add 11 more shades to their best-selling [Born This Way foundation collection](https://www.glamour.com/story/too-faced-jackie-aina-foundation) and makeup company Anastasia partnered with her to develop [a shadow palette of 14 colors](https://www.anastasiabeverlyhills.com/jackie-aina-palette/ABH01-18184.html) begging to be brushed across beautiful brown skin.\n",
        "website": "https://www.jackieaina.com/",
        "claimToFame": "Aina is a beauty expert and activist who has made it her business to see black women represented in the color spectrum of makeup brands.\n",
        "influence": 199.8,
        "reach": 14.06,
        "substance": 7.3,
        "instagramUrl": "https://www.instagram.com/jackieaina/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "01tgVNjdNvNHAEiCHr1vs4",
        "type": "Entry",
        "createdAt": "2019-09-19T15:51:28.924Z",
        "updatedAt": "2019-09-20T12:41:41.613Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 75,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/ta-nehisi.coates.jpg",
        "name": "Ta-Nehisi Coates",
        "job": "Writer, author",
        "sector": "Arts",
        "twitterAccount": "tanehisicoats",
        "location": "New York City",
        "age": 43,
        "bio": "Besides being one of the most prolific and intellectual writers on race, culture and politics in this generation, Coates has a laser perception for knitting together the overlooked points of an issue. In 2014, when he was a national correspondent for _The Atlantic_, he wrote [&quot;The Case for Reparations,&quot;](https://www.theatlantic.com/magazine/archive/2014/06/the-case-for-reparations/361631/) a subject that&#39;s always seemed so far-removed from ever being an actual thing, largely because no one could ever agree on it. Fast forward to this year&#39;s election when [nearly every Democratic candidate mentioned reparations](https://www.vox.com/policy-and-politics/2019/3/11/18246741/reparations-democrats-2020-inequality-warren-harris-castro) as part of their platform and it&#39;s clear that Coates is a man who doesn&#39;t respond to discussions—he leads them. In [the most elegant ethering ever delivered in front of Congress](https://www.youtube.com/watch?v=kcCnQ3iRkys), he ran down [Mitch McConnell&#39;s claims](https://www.politico.com/video/2019/06/19/mitch-mcconnell-doesnt-think-reparations-for-slavery-are-a-good-idea-068329) that reparations aren&#39;t due because the people responsible are dead. Now a distinguished writer in residence at New York University, Coates&#39; [first novel,](https://ta-nehisicoates.com/books/the-water-dancer/) [_The Water Dancer_](https://ta-nehisicoates.com/books/the-water-dancer/), debuted [to exquisite reviews](https://ew.com/book-reviews/2019/09/16/ta-nehisi-coates-the-water-dancer/?fbclid=IwAR11ouAAYcR754pqpSPCmB9XL-iijI9ZxuprXc0RfDysCTKNHJH9fdGQ7Wc), another stellar achievement in an already stellar career.",
        "website": "https://ta-nehisicoates.com/",
        "claimToFame": "Coates is adding to his legacy of thought leadership by continuing to drive the conversation on reparations and putting more great writing out into the art atmosphere with his first novel, _The Water Dancer._",
        "influence": 143.8,
        "reach": 9.68,
        "substance": 6.8,
        "instagramUrl": "https://www.instagram.com/tanehisipcoates/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5qjjJsuwPZjrMOlU2mXX3p",
        "type": "Entry",
        "createdAt": "2019-09-17T22:31:00.779Z",
        "updatedAt": "2019-09-18T16:14:04.847Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 100,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/elizabeth.lindsey.jpg",
        "name": "Elizabeth Lindsey",
        "job": "Executive director, Byte Back",
        "sector": "STEM",
        "twitterAccount": "elindse1",
        "location": "Washington, D.C.",
        "age": 39,
        "bio": "Elizabeth Lindsey wants to ensure underserved communities aren&#39;t left out of good-paying jobs in the technology sector. Lindsey is the executive director of [Byte Back](https://byteback.org/about/), an organization that provides job training and career services so that individuals will be able to secure living-wage tech careers. Under Lindsey&#39;s leadership, Byte Back has won several grants to help further its cause, including $100,000 from [Kapor Center&#39;s inaugural Tech Done Right Challenge](https://www.americaninno.com/dc/funding-dc/new-money-dc-area-startups-raise-102m-of-funding-in-july/) and $775,000 from [TD Bank](https://technical.ly/dc/2018/10/24/byte-back-wins-775000-grant-to-expand-to-baltimore-in-2019/) to expand into Baltimore.",
        "website": "https://byteback.org/",
        "claimToFame": "Lindsey is the executive director of Byte Back, an organization that trains underrepresented communities in tech-sector careers.",
        "influence": 107.4,
        "reach": 7.8,
        "substance": 6.4
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "52QJXarWPQZ6Ma3Ww9IqzR",
        "type": "Entry",
        "createdAt": "2019-09-17T19:37:56.772Z",
        "updatedAt": "2019-09-24T22:54:01.793Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 70,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/candice.elder.jpg",
        "name": "Candice Elder",
        "job": "Founder and executive director, the East Oakland Collective",
        "sector": "Community",
        "twitterAccount": "portiaelder",
        "location": "Oakland, Calif.",
        "age": 35,
        "bio": "Candice Elder wants to save her hood. As the founder and executive director of the [East Oakland Collective](http://www.eastoaklandcollective.com/), Elder is working to address disinvestment and lack of resources in her neighborhood. Home of the Black Panther Party, Oakland has been hit with massive gentrification over the past decade as the tech boom has driven many people of color in the Bay Area to look for cheaper housing. Still, Elder&#39;s neighborhood of deep East Oakland remains a bastion for black residents and she&#39;s working to make sure her community controls their own future. Along with the East Oakland Collective, Elder has launched Feed the Hood, [a bi-monthly program](https://sanfrancisco.cbslocal.com/2018/11/05/feed-the-hood-provides-for-east-bay-homeless/) that&#39;s provided more than 23,000 lunches and hygiene kits to 3,000 homeless residents.",
        "website": "http://www.eastoaklandcollective.com",
        "claimToFame": "As founder and director of East Oakland Collective, Elder is battling the encroaching gentrification of her community while also launching programs to help the most vulnerable.",
        "influence": 150.2,
        "reach": 6.1,
        "substance": 7.8,
        "instagramUrl": "https://www.instagram.com/eastoaklandcollective/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "4se5uGDxtXsHMHMYeFLEIv",
        "type": "Entry",
        "createdAt": "2019-09-19T21:04:14.223Z",
        "updatedAt": "2019-09-23T19:50:41.700Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 7,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 25,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/kristen.clarke.jpg",
        "name": "Kristen Clarke",
        "job": "President and executive director of the National Lawyers' Committee for Civil Rights Under Law",
        "sector": "Community",
        "twitterAccount": "KristenClarkeJD",
        "location": "Washington, D.C.",
        "age": 44,
        "bio": "As the [president and executive director](https://lawyerscommittee.org/staff/kristen-clarke/) of the National Lawyers&#39; Committee for Civil Rights Under Law, Kristen Clarke focuses on protecting the rights of black Americans and other historically marginalized communities. A champion of expanding voting rights, Clarke [successfully led the effort](https://www.huffpost.com/entry/census-citizenship-question-blocked_n_5c8020cfe4b0e62f69e95de8) to prevent the Trump administration from adding a citizenship question to the 2020 Census that could have prevented immigrant communities from being counted. As an attorney, she also helped the first African-American female student body president of American University [win a $725,000 settlement](https://www.nytimes.com/2019/08/10/us/taylor-dumpson.html) from the publisher of a neo-Nazi website who led a &quot;troll storm&quot; against her. Before joining the Lawyers&#39; Committee, Clarke served as the head of the Civil Rights Bureau for the New York State Attorney General&#39;s Office, and worked for the NAACP Legal Defense and Educational Fund, where she fought against restrictions to voting access.",
        "website": "https://lawyerscommittee.org/",
        "claimToFame": "As president and executive director of the National Lawyers' Committee for Civil Rights Under Law, Clarke led the fight to keep the Trump administration's citizenship question off the 2020 Census.",
        "influence": 188.3,
        "reach": 9.58,
        "substance": 7.8,
        "instagramUrl": "https://www.instagram.com/kristenclarke"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3nOHon4pSJkzVecTmitAUE",
        "type": "Entry",
        "createdAt": "2019-09-18T00:30:44.943Z",
        "updatedAt": "2019-09-20T21:46:10.237Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 47,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/Latoya.Shauntay.Snell.jpg",
        "name": "Latoya Shauntay Snell",
        "job": "Marathon runner, chef",
        "sector": "Community",
        "twitterAccount": "latoyashauntay",
        "location": "New York City",
        "age": 34,
        "bio": "Snell doesn&#39;t care if she&#39;s dead last when she runs a marathon. The very fact that she&#39;s running a marathon at all is amazing to her and the thousands of followers inspired by her journey through weight gain and loss and gain again, health diagnoses, and self-acceptance that&#39;s blossomed into self-love. She became a competitive runner by accident, like most callings, when [she finished the 2013 Rock &#39;n Roll Run](https://www.elle.com/culture/career-politics/a24525085/latoya-shauntay-snell-running-fat-chef-marathon/). It seemed like a goal accomplished but it made Snell confront her issues with weight, body image and alcohol. She got clean, she got healthy and the badass ultramarathoner metamorphosed into a dream chaser and serial competitor in high-profile events like New York City marathon despite moderate-level sciatica and [sometimes startling heckles](https://theglowup.theroot.com/im-a-plus-size-runner-and-i-got-heckled-at-the-nyc-mara-1820797012). Her blog, [Running Fat Chef](https://www.runningfatchef.com/aboutme.html), is a wealth of tips and inspiration for folks who don&#39;t look like skinny, white athletic poster children for the sport. In 2019, the mom of one has run 10 marathons—and she ain&#39;t stopping.",
        "website": "https://www.runningfatchef.com/",
        "claimToFame": "As a plus-sized black woman in a predominantly white sport, Snell makes athleticism and marathon-running look and feel accessible to people inspired by her curves and courage.",
        "influence": 169,
        "reach": 9.03,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/iamlshauntay/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "28k2477e0NU0cnsfDC2d1Z",
        "type": "Entry",
        "createdAt": "2019-09-10T13:01:44.297Z",
        "updatedAt": "2019-09-20T21:41:44.025Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 9,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568650817/janet.mock_retouch_lyzt69.jpg",
        "name": "Janet Mock",
        "job": "Writer, producer, director",
        "sector": "Entertainment",
        "twitterAccount": "janetmock",
        "location": "New York City and Los Angeles",
        "age": 36,
        "bio": "Mock built an exemplary career as a journalist and author, and after proving herself as [writer, director and producer of the acclaimed FX show, _Pose_](https://www.fxnetworks.com/shows/pose/cast-crew/janet-mock-producer-director-writer)—where [she made history](https://theglowup.theroot.com/love-is-the-message-janet-mock-makes-her-directorial-d-1827437705) in her directorial debut—she&#39;s signed [a multimillion-dollar megadeal with Netflix](https://variety.com/2019/tv/features/janet-mock-netflix-deal-pose-1203246917/) to generate more great must-see content. The three-year agreement, which includes a first-look option on feature film projects, gives the multitalented storyteller and activist creative space to produce [exclusive shows for the streaming powerhouse](https://www.npr.org/2019/08/14/750931179/on-pose-janet-mock-tells-the-stories-she-craved-as-a-young-trans-person) that will not only center people of color and LGBTQ folks, but more proportionately employ them in the behind-camera roles that bring them to the screen. The stipulations also enable her to stay on board at _Pose_, [now in its second season](https://www.buzzfeed.com/patricepeck/pose-behind-the-scenes-facts?bfsource=relatedmanual), and work alongside its co-creator Ryan Murphy as executive producer and director on his upcoming Netflix series, _Hollywood_. The blockbuster deal was historic, making Mock the first transgender woman to make a content deal with [a major studio](https://thegrapevine.theroot.com/janet-mock-makes-history-by-becoming-the-1st-black-tran-1835661400).",
        "website": "https://janetmock.com/",
        "claimToFame": "Mock, whose talents have helped elevate the hit series, _Pose_, signed a historic deal with Netflix, becoming the first transgender woman to shape content at a major Hollywood company.",
        "influence": 218.4,
        "reach": 13.56,
        "substance": 7.7,
        "instagramUrl": "https://www.instagram.com/janetmock/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "RS1YYqc4Y99oWwSGoJZTW",
        "type": "Entry",
        "createdAt": "2019-09-19T14:26:48.839Z",
        "updatedAt": "2019-09-23T23:13:23.927Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 5,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/Oronike.Odeleye.jpg",
        "name": "Oronike Odeleye",
        "job": "Activist",
        "sector": "Community",
        "twitterAccount": "SuiteLadyOro",
        "location": "Atlanta",
        "age": 39,
        "bio": "Across all platforms, dream hampton&#39;s six-part _Surviving R. Kelly_ series was Lifetime&#39;s most successful social premiere ever. But before it took documentary form, the movement to finally hold the R&B singer accountable had already been accumulating steam and solidarity because of [the grassroots activism of Odeleye](https://www.papermag.com/mute-r-kelly-2626090782.html?rebelltitem=5#rebelltitem5) and her #MuteRKelly co-founder Kenyette Tisha Barnes (who was ineligible for this year&#39;s list because of the age restriction). Even without the backing of musicians and artists who&#39;ve worked with Kelly but have been unwilling to publicly go on record to denounce his pathologically criminal and predatory behavior, Odeleye co-led the movement that finally [held the Pied Piper of R&amp;B legally accountable](https://www.npr.org/2019/08/02/746684479/r-kelly-pleads-not-guilty-to-federal-charges-in-new-york) and confronted him with federal charges in New York and Chicago. Aided by the timing of #MeToo and #TimesUp, the arts and entertainment consultant has still had to scream twice as loud and fight twice as hard because the victims in her cases are black and brown girls. The war isn&#39;t over—Odeleye is throwing [her change-making power](https://100women.okayafrica.com/editorial/oronikeodeleye) against the sexual harassment that&#39;s so pervasive and ingrained in the music industry.",
        "website": "https://www.muterkelly.org/",
        "claimToFame": "Odeleye co-led the #MuteRKelly movement all the way to the courthouse, where the Pied Piper of R&amp;B was finally indicted.",
        "influence": 231.4,
        "reach": 9.79,
        "substance": 8.6,
        "instagramUrl": "https://www.instagram.com/officialmuterkelly/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "39AQmLD03KzfQQfzDyYaZX",
        "type": "Entry",
        "createdAt": "2019-09-17T22:02:53.229Z",
        "updatedAt": "2019-09-25T17:41:15.735Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 90,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/denise.woodard.jpg",
        "name": "Denise Woodard",
        "job": "Founder, Partake Foods",
        "sector": "Business",
        "twitterAccount": "partakefoods",
        "location": "Jersey City, N.J.",
        "age": 36,
        "bio": "Denise Woodard didn&#39;t set out to make her own company, but after her daughter was [diagnosed with multiple food allergies](https://www.blackenterprise.com/black-owned-vegan-cookie-company-closes-1-million-from-jay-zs-venture-fund/), she decided to do something about it. In 2016, Woodard founded [Partake Foods,](https://partakefoods.com/) which sells vegan, gluten-free, and allergy-friendly cookies. Recently, Partake Foods [secured $1 million in capital](https://www.forbes.com/sites/maryannreid/2019/08/13/jay-z-invested-in-this-female-founded-business-heres-how-she-grew-her-company/?fbclid=IwAR2WRzHK5TIBHk4nPvQ9pWCBHY84ZhuMaXETk9Ld8rqfyP5WgUZH3iX_irk#357f55c95cd9) from investors, including Jay-Z&#39;s fund, Marcy Venture Partners. The investment not only generated buzz for Partake Foods, but it also helped the company expand to [more than 300 stores](https://www.blackenterprise.com/black-owned-vegan-cookie-company-closes-1-million-from-jay-zs-venture-fund/).",
        "claimToFame": "The former Coca-Cola executive is founder of Partake Foods, which sells vegan, gluten-free and allergy-friendly foods in more than 300 stores around the country.",
        "influence": 135,
        "reach": 7.59,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/partakefoods/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "4btnAG6v1puvXi3d9RnsrG",
        "type": "Entry",
        "createdAt": "2019-09-17T22:39:58.580Z",
        "updatedAt": "2019-09-25T17:32:48.110Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 15,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704272/The%20Root%20100%202019/ibram.kendiV2.jpg",
        "name": "Ibram X. Kendi",
        "job": "Author, professor at American University",
        "sector": "Community",
        "twitterAccount": "DrIbram",
        "location": "Washington, D.C.",
        "age": 37,
        "bio": "Ibram X. Kendi wants to help America to be antiracist. He is the founding director of the [Antiracist Research and Policy Center](https://www.american.edu/centers/antiracism/) at American University, where the goal is to produce thorough and accessible research to better implement antiracist public policies. To that end, in April, Kendi and the ARPC launched the first ever [Antiracism Book Festival](https://www.american.edu/centers/antiracism/), “the first and only book festival that brings together, showcases and celebrates the nation’s leading antiracist writers and helps to prepare the writers of tomorrow.\" His latest bestselling book, _How to Be an Antiracist_, should be required reading for those who remain unclear on how to define racism. In August, Kendi teamed up with acclaimed young adult writer Jason Reynolds (also an honoree on this list), to transform his work into a manuscript for young people. The pair will be releasing [_Stamped: Racism, Antiracism, and You_](https://www.amazon.com/dp/0316453692/ref=sr_1_fkmr1_2?keywords=stamped%3A+racism%2C+anti+racism+and+you&amp;qid=1566232102&amp;s=gateway&amp;sr=8-2-fkmr1), which Kendi hopes will help younger generations understand—and ultimately eradicate—racism.",
        "website": "https://www.ibramxkendi.com/",
        "claimToFame": "The professor and founding director of the Antiracist Research and Policy Center at American University is the bestselling author of _How to Be an Antiracist_.",
        "influence": 203.1,
        "reach": 12.36,
        "substance": 7.6
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "12M1V16vKtH1EhozRmW40D",
        "type": "Entry",
        "createdAt": "2019-09-19T22:00:50.244Z",
        "updatedAt": "2019-09-20T12:36:24.865Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 62,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/tiffany.cross.jpg",
        "name": "Tiffany Cross",
        "job": "Co-founder, managing editor of The Beat DC",
        "sector": "Media",
        "twitterAccount": "tiffanydcross",
        "location": "Washington, D.C.",
        "age": 41,
        "bio": "[Tiffany Cross](http://tiffanydcross.com/new-index-1) has the pulse of Washington, D.C. As the co-founder and managing editor of The Beat DC—[a publication that focuses on the intersection of politics, policy, and people of color](https://www.thebeatdc.com/)—Cross regularly covers the political movers and shakers in the Beltway and beyond. A veteran media professional, Cross was previously the D.C. bureau chief for BET News and an associate producer with CNN. An in-demand analyst, Cross has also worked with several local, state, and federal candidates and issue campaigns.",
        "website": "https://www.tiffanydcross.com/",
        "claimToFame": "The co-founder and managing editor of The Beat DC is regularly called on to offer thoughtful commentary on MSNBC and other platforms.",
        "influence": 158.4,
        "reach": 11.07,
        "substance": 6.9,
        "instagramUrl": "https://www.instagram.com/tiffanydcross/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6hDd9r3zVn9MUrT3mKx00b",
        "type": "Entry",
        "createdAt": "2019-09-17T18:45:10.620Z",
        "updatedAt": "2019-09-20T19:15:19.955Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 78,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568827487/Akbar_Cook2_dly93p.jpg",
        "name": "Akbar Cook",
        "job": "Principal, Newark West Side High School",
        "sector": "Community",
        "twitterAccount": "principalakbar",
        "location": "Newark, N.J.",
        "age": 43,
        "bio": "As the principal of Newark&#39;s West Side High School, Cook has done everything in his power to keep his students safe. Last year, Cook earned [a spot on our list](http://interactives.theroot.com/root-100-2018/#akbar-cook) after he opened [an on-campus laundry room](https://www.theroot.com/to-combat-bullying-newark-n-j-high-school-principal-1828389604) to give bullied kids a place to wash their clothes. And Cook keeps on stepping up for his students in a major way. He launched [the &quot;Lights On&quot; program](https://www.njtvonline.org/news/video/lights-on-program-at-west-side-high-school-draws-national-attention/), a recreational program that keeps the campus open from 6 p.m. to midnight on Fridays to give his students a place to be during the hours that can be the most perilous for teens. Cook&#39;s efforts have been recognized by [Ellen Degeneres](https://www.youtube.com/watch?v=O1P6oZjfR54), [Sen. Cory Booker](https://www.youtube.com/watch?v=sQdUHjUUpIQ), and [Oprah Winfrey](https://www.youtube.com/watch?v=MxZIj-nyTlI), who donated $500,000 to the school.",
        "website": "https://www.nps.k12.nj.us/wsd/",
        "claimToFame": "The dedicated principal has been honored by local and national media for his commitment to his students.",
        "influence": 141.4,
        "reach": 8.33,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/principal_akbar/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5VwHGopteE7RO7OQwwyxHW",
        "type": "Entry",
        "createdAt": "2019-09-19T21:49:23.173Z",
        "updatedAt": "2019-09-20T12:38:22.060Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 16,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/serena.williams.jpg",
        "name": "Serena Williams",
        "job": "Athlete, entrepreneur",
        "sector": "Sports",
        "twitterAccount": "SerenaWilliams",
        "location": "Miami, Fla.",
        "age": 37,
        "bio": "There&#39;s no denying Serena Williams is the GOAT. Though she failed to capture that elusive 24th Grand Slam title to tie Margaret Court&#39;s all-time record, she still managed to make the finals of both Wimbledon and the U.S. Open this year, which is quite a feat for an athlete about to turn 38. But her influence stretches far beyond the court. [According to Forbes](https://www.forbes.com/profile/serena-williams/#214452ac4e48), Queen Serena has invested in 34 startups through Serena Ventures, including [Mahmee](https://www.forbes.com/sites/estrellajaramillo/2019/07/15/mahmee-raises-3m-serena-williams-mark-cuban-to-disrupt-prenatal-and-postpartum-care/#2736ecfd5d1a), a maternal and infant health tech company. In 2018 she launched [S by Serena](https://www.serenawilliams.com/pages/aboutserena), an inclusive clothing line that celebrates women of all sizes. While being a badass champion and bawse is more than enough, since giving birth to her daughter, Alexis Olympia Ohanian Jr., in 2017, Williams has been very vocal about black maternal health. And Serena continued to redefine beauty standards with [her stunning Harper&#39;s Bazaar](https://theglowup.theroot.com/winning-serena-williams-makes-the-wimbledon-semifinals-1836216226) cover where she—and her backside—appeared unretouched.",
        "website": "https://www.serenawilliams.com/",
        "claimToFame": "Williams is not only the greatest tennis player of all time, she&#39;s also a successful entrepreneur, fashion icon and mother.",
        "influence": 202.5,
        "reach": 18.09,
        "substance": 6.9,
        "instagramUrl": "https://www.instagram.com/serenawilliams/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "yqPwqCMs1HyPzzI30s8zX",
        "type": "Entry",
        "createdAt": "2019-09-18T23:48:44.702Z",
        "updatedAt": "2019-09-23T23:58:39.839Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 44,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568650818/angelica.ross_retouch_tysjo6.jpg",
        "name": "Angelica Ross",
        "job": "Actor, writer, producer",
        "sector": "Entertainment",
        "twitterAccount": "angelicaross",
        "location": "Los Angeles",
        "age": 31,
        "bio": "When Ross exited [FX&#39;s hit series _Pose_](https://www.fxnetworks.com/shows/pose), it was [an emotional TV moment](https://www.shondaland.com/live/a28340800/pose-angelica-ross-candy-ferocity-death/?utm_campaign=likeshopme&amp;utm_medium=instagram&amp;utm_source=dash+hudson&amp;utm_content=www.instagram.com%2Fp%2FB0D_qi7AWfS%2F) because who didn&#39;t love them some Candy Ferocity? The landmark show for the LGBTQ community, its allies and everyone else who stans for a good, quality ballroom battle was a door-opener for the actress, but it also highlighted the [chronically untold stories of violence against black trans women](https://www.hollywoodreporter.com/live-feed/pose-death-explained-ryan-murphy-janet-mock-violence-trans-women-color-1223057). Ross is taking her talents to the cast of [_American Horror Story_](https://www.fxnetworks.com/shows/american-horror-story)—making her [the first trans person to secure two back-to-back starring series roles](https://www.out.com/television/2019/7/10/angelica-ross-makes-history-new-american-horror-story-castmember)—but offscreen, the multihyphenate activist for LGBTQ and racial equality is founder of [TransTech Social Enterprises](https://www.transtechsocial.org/), a company that empowers trans, lesbian, gay, bisexual and queer people with job skills training in a co-learning community. In September, she made history again as [the first trans person to host a presidential forum](https://www.out.com/politics/2019/9/16/angelica-ross-will-be-first-trans-person-host-presidential-forum), a platform to address the pertinent issues in an undervalued voting bloc.",
        "website": "https://missross.com/",
        "claimToFame": "Ross is just out here making all kinds of history as the first trans person to lock down back-to-back starring series roles, all while empowering LGBTQ people to live their best lives.",
        "influence": 171.1,
        "reach": 12.19,
        "substance": 7.2,
        "instagramUrl": "https://www.instagram.com/angelicaross/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5mmGnRQisueiId2g0dwll2",
        "type": "Entry",
        "createdAt": "2019-09-10T18:20:28.644Z",
        "updatedAt": "2019-09-16T16:24:27.288Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 49,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704277/The%20Root%20100%202019/melina.matsoukas.jpg",
        "name": "Melina Matsoukas",
        "job": "Director",
        "sector": "Entertainment",
        "twitterAccount": "melinamatsoukas",
        "location": "Los Angeles",
        "age": 38,
        "bio": "\nIt&#39;s impossible to be the [directorial mastermind behind videos for genius women](https://www.newyorker.com/magazine/2017/03/06/the-provocateur-behind-beyonce-rihanna-and-issa-rae) like Beyoncé, Solange and Rihanna and not be a genius woman in her own right. Matsoukas&#39; collective body of work is an ode to the limitlessness of black creativity, from her brilliantly directed ads for major brands like Nike, Lexus and Diet Coke to her leadership as an [executive producer and director of our favorite HBO show,](https://www.youtube.com/watch?v=BZbyXokpCzE) [_Insecure_](https://www.youtube.com/watch?v=BZbyXokpCzE). You know you&#39;re that chick when Queen Bey presents [_you_ with an award](https://thegrapevine.theroot.com/2019-afi-lifetime-achievement-ceremony-denzel-washingt-1835323318), but that wasn&#39;t even the pinnacle of the auteur&#39;s receipt of the American Film Institute&#39;s prestigious [Franklin J. Schaffner Alumni Medal](https://ew.com/awards/2019/06/07/beyonce-makes-surprise-appearance-at-afi-gala-to-honor-melina-matsoukas/) this year—she made history as the first woman of color to ever receive the honor. And with her feature film directorial debut of the Lena Waithe-penned _Queen &amp; Slim_, the Grammy Award winner should probably get more acceptance speeches ready.",
        "website": "http://prettybird.co/us/talent/creatives/melina-matsoukas/work/",
        "claimToFame": "Matsoukas is Beyoncé&#39;s favorite director and her upcoming feature film, _Queen &amp; Slim_, may make her yours, too.",
        "influence": 168.9,
        "reach": 11.88,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/msmelina/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "MdGxXEaTQfdFq0QK2MhYF",
        "type": "Entry",
        "createdAt": "2019-09-17T23:42:37.428Z",
        "updatedAt": "2019-09-18T16:16:14.654Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 86,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704272/The%20Root%20100%202019/kamilah.forbes.jpg",
        "name": "Kamilah Forbes",
        "job": "Executive producer of the Apollo Theater",
        "sector": "Arts",
        "twitterAccount": "kamilahf",
        "location": "New York City",
        "age": 43,
        "bio": "Kamilah Forbes wants to ensure the Apollo Theater remains a beacon of cultural influence. As the [executive producer at the historic institution](https://www.apollotheater.org/about/leadership/), Forbes is committed to &quot;the development of creative works by, for, and about the hip-hop generation.&quot; She was instrumental in bringing [the theatrical production](https://www.theroot.com/kamilah-forbes-beautiful-struggle-bringing-ta-nehisi-1825144286) of noted author and journalist Ta-Nehisi Coates&#39; Baldwin-inspired letter to his son, _Between the World and Me,_ to the stage. Forbes has produced several groundbreaking programs, including _Nas&#39; 20 Year Anniversary of Illmatic_ and _One Mic_—a month­long celebration of hip­-hop around the world. Next, the veteran theater producer is turning her eye to Broadway: Forbes has partnered with Dominique Morisseau, Ahmir &quot;Questlove&quot; Thompson and Camille A. Brown [to bring](https://www.hollywoodreporter.com/news/soul-train-musical-sets-team-broadway-debut-1232938) [_Soul Train_](https://www.hollywoodreporter.com/news/soul-train-musical-sets-team-broadway-debut-1232938) [to the Great White Way.](https://www.hollywoodreporter.com/news/soul-train-musical-sets-team-broadway-debut-1232938)\n",
        "website": "https://www.apollotheater.org/",
        "claimToFame": "As executive producer of the world-famous Apollo Theater in New York City, Forbes is ensuring the iconic theater remains the epicenter of black culture for a new generation.",
        "influence": 138.4,
        "reach": 7.97,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/kamilahf/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "104wNytFVcF6EMLL3qubdT",
        "type": "Entry",
        "createdAt": "2019-09-19T21:34:45.600Z",
        "updatedAt": "2019-09-20T12:39:16.740Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 67,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568650817/micah.mcdonald_retouch_iwulia.jpg",
        "name": "Micah McDonald",
        "job": "Stylist",
        "sector": "Entertainment",
        "location": "Los Angeles",
        "age": 33,
        "bio": "In demand [celebrity stylist](https://theglowup.theroot.com/it-takes-a-very-stylish-village-thr-celebrates-the-s-1833280482) Micah McDonald has one mission: &quot;Create beautiful images and tell a story.&quot; [The Ohio native](https://www.waymanandmicah.com/about-1/) is a graduate of the Fashion Institute of Technology, where he studied styling and merchandising. After working with several brands, including Marc Jacobs, McDonald decided to pursue styling full time. Eventually, he teamed up with his friend and fellow stylist, Wayman Bannerman, to form Wayman + Micah. The Hollywood Reporter named the duo two of [the most powerful stylists in Hollywood](https://www.hollywoodreporter.com/lists/25-top-stylists-hollywood-2018-1093944).",
        "website": "https://www.waymanandmicah.com/",
        "claimToFame": "Along with his partner, Wayman Bannerman, McDonald was named one of the most powerful stylists in Hollywood.",
        "influence": 153.5,
        "reach": 7.45,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/mcdonaldmicah/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "4R9NPTd4ZYuus1G2khVZtR",
        "type": "Entry",
        "createdAt": "2019-09-17T23:02:11.036Z",
        "updatedAt": "2019-09-24T22:29:14.866Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 60,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/jeffreen.hayes.jpg",
        "name": "Jeffreen Hayes",
        "job": "Executive director, Threewalls",
        "sector": "Arts",
        "location": "Chicago",
        "age": 44,
        "bio": "In 1968, a collective of five artists in Chicago assumed the responsibility of creating positive images of Black people and their lives. They called themselves [AfriCOBRA—the African Commune of Bad Relevant Artists](https://www.africobranow.com/). Hayes learned about the group and their work as a graduate student at Howard University and to commemorate its 50th anniversary in this current wave of political activism, she curated &quot;[AfriCOBRA: Messages to the People](https://www.artinamericamagazine.com/reviews/africobra-messages-to-the-people/),&quot; an exhibition at the Museum of Contemporary Art North Miami. Following that successful showing, she developed its next chapter, &quot;[AfriCOBRA: Nation Time](https://mocanomi.org/2019/03/africobra-nation-time/),&quot; which showed at the [Venice Biennale Arte 2019](https://www.labiennale.org/en/art/2019). It was the first major exhibition of the collective&#39;s work in Europe and the first time the AfriCOBRA artists, who are still active, have been given an international platform of this scale. It&#39;s another major achievement in Hayes&#39; long resume of weaving art, culture and underrepresented voices into stunning visual experiences.",
        "website": "https://three-walls.org/",
        "claimToFame": "Hayes introduced the work of AfriCOBRA, a black arts collective, to an international audience as curator of a history-making exhibit.",
        "influence": 159.1,
        "reach": 7.59,
        "substance": 7.6
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "36cBrDbJJVqJ0egOFFxvLN",
        "type": "Entry",
        "createdAt": "2019-09-19T20:43:47.048Z",
        "updatedAt": "2019-09-25T17:19:04.161Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 30,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704274/The%20Root%20100%202019/crissle.west.jpg",
        "name": "Crissle West",
        "job": "Co-host of The Read podcast, TV show",
        "sector": "Entertainment",
        "twitterAccount": "crissles",
        "location": "New York City",
        "age": 37,
        "bio": "Crissle West does not mince words. As one-half of the popular podcasting team behind _The Read_, West regularly discusses everything from pop culture to politics. A staunch advocate for mental health, West launched &quot;Crissle&#39;s Couch&quot; on _The Read_ to answer questions, discuss her struggles with things like depression and anxiety, and remove the stigma around therapy. And now the popular podcaster is taking her talents to TV. West and her co-host Kid Fury (also an honoree on the list) will debut _The Read With Kid Fury And Crissle West_ on [Fuse TV in October](https://thegrapevine.theroot.com/oh-happy-day-the-read-with-kid-fury-and-crissle-west-i-1837266675).",
        "website": "https://www.crissle.com/",
        "claimToFame": "Crissle, along with _The Read_ co-host Kid Fury, is bringing the popular podcast to Fuse TV in October.",
        "influence": 182.6,
        "reach": 10.54,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/crissle/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3QwnqoHpcrnmar1THI8QId",
        "type": "Entry",
        "createdAt": "2019-09-10T12:53:13.409Z",
        "updatedAt": "2019-09-20T21:43:56.322Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 24,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/donald.glover.jpg",
        "name": "Donald Glover",
        "job": "Actor, musician",
        "sector": "Entertainment",
        "twitterAccount": "donaldglover",
        "location": "Atlanta",
        "age": 35,
        "bio": "The official video for &quot;[This Is America](https://www.youtube.com/watch?v=VYOjWnS4cMY&amp;feature=youtu.be)&quot; on Donald Glover&#39;s YouTube channel has been viewed a cool 593 million times and counting. It&#39;s  four minutes of musical and visual social commentary and it takes more than one viewing to pick up on all of the points the shirtless and shoeless artist formerly known as Childish Gambino is making. Aside from its critical acclaim, [explainers](https://www.theroot.com/donald-glovers-this-is-america-explained-by-2-people-wh-1825858343) and deconstructions, Glover&#39;s opus grabbed the Recording Academy&#39;s attention four times, earning Grammys for Best Music Video, Best Rap/Sung Performance, and making history by winning Record of the Year and Song of the Year, [the first time](https://variety.com/2019/music/news/hip-hop-makes-history-grammys-childish-gambino-1203135348/) in the awards&#39; 61-year history that a rap song received those top honors. Now that Childish Gambino has ([maybe?](https://www.nme.com/news/music/donald-glover-update-on-future-of-childish-gambino-2526873)) retired, Glover can now focus his attention of blessing us with [seasons 3 and 4](https://www.rollingstone.com/tv/tv-news/atlanta-season-4-renewed-868200/) of his beloved hit series, _Atlanta._",
        "website": "http://www.childishgambino.com",
        "claimToFame": "Glover made music history when his alter ego Childish Gambino&#39;s &quot;This Is America&quot; became the first rap song to win Grammys for both Song and Record of the Year.",
        "influence": 190.4,
        "reach": 16.95,
        "substance": 6.8,
        "instagramUrl": "https://www.instagram.com/childishgambino/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6shB9Q8ttsLUm2p3OWD8vf",
        "type": "Entry",
        "createdAt": "2019-09-17T23:15:37.972Z",
        "updatedAt": "2019-09-18T16:15:44.249Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 13,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/jeremy.harris.jpg",
        "name": "Jeremy O. Harris",
        "job": "Playwright",
        "sector": "Arts",
        "twitterAccount": "jeremyoharris",
        "location": "New York City",
        "age": 30,
        "bio": "Before becoming an award-winning playwright, [Jeremy O. Harris](https://www.nytimes.com/2018/11/28/theater/jeremy-o-harris-slave-play.html) thought about becoming a lawyer, but he studied acting and took a string of retail gigs before finally writing his first play, _Xander Xyst, Dragon 1_. The drama led to a residency at the MacDowell Colony, where he penned _Daddy_, about a young black artist who gets into a relationship with an older white art collector. That work would be the writing sample he submitted to the Yale School of Drama, where he studied playwrighting. In 2018, Harris&#39; most ambitious work to date, _Slave Play_, debuted at the New York Theatre Workshop to rave reviews and [some controversy](https://www.theroot.com/rising-playwright-jeremy-o-harris-addresses-backlash-o-1831545447). Earlier this month, the play—which has been described as &quot;an antebellum fever-dream&quot;—made [its Broadway debut](https://www.theroot.com/it-should-cost-you-something-as-it-debuts-on-broadway-1837972463) at the Golden Theatre.",
        "website": "https://jeremyoharris.me/bio",
        "claimToFame": "Playwright Jeremy O. Harris&#39; ambitious work, _Slave Play_, has become the talk of Broadway.",
        "influence": 203.7,
        "reach": 10.65,
        "substance": 7.9,
        "instagramUrl": "https://www.instagram.com/jeremyoharris/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5xcsuvwkExaruwxKQOAjJK",
        "type": "Entry",
        "createdAt": "2019-09-11T18:40:05.733Z",
        "updatedAt": "2019-09-20T19:02:34.740Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 28,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704269/The%20Root%20100%202019/Ayanna.Pressley.jpg",
        "name": "Ayanna Pressley",
        "job": "U.S. Representative, Massachusetts",
        "sector": "Politics",
        "twitterAccount": "AyannaPressley",
        "location": "Washington, D.C., and Boston",
        "age": 45,
        "bio": "Never mind being a freshman in the House. Pressley, [the first black woman to represent Massachusetts in Congress](https://slate.com/news-and-politics/2018/09/ayanna-pressley-defeats-mike-capuano-in-massachusetts-7th-district.html), has had the kind of fire-by-baptism year that turns newbies into veterans pretty fast. Her first days in office were a blitz of action to reform policies that overwhelmingly affect and disenfranchise black and brown people, from [restoring voting rights](https://www.washingtonpost.com/news/powerpost/paloma/powerup/2019/04/26/powerup-democrats-debate-rights-of-felons-to-vote/5cc1e5061ad2e52459e2469d/?noredirect=on) for formerly incarcerated Americans to breaking with Democratic Party leaders to [denounce border funding](https://www.bostonglobe.com/news/politics/2019/06/25/ayanna-pressley-one-four-democrats-vote-border-aid-bill/YewwzoI6k1FURGkV7tuDLN/story.html). Pressley, who has made [our list](https://onehundred.theroot.com/facewall/the-root-100-2012/#ayanna_pressley-2) on [three](https://www.theroot.com/thesquad-claps-back-at-trump-s-go-back-to-your-own-c-1836395868) previous [occasions](http://interactives.theroot.com/root-100-2018/#ayanna-pressley), famously called out the embattled president as a racist, but when he later attacked her and the other members of the power quadripartite known as &quot;[The Squad,](https://www.theroot.com/thesquad-claps-back-at-trump-s-go-back-to-your-own-c-1836395868)&quot; Pressley didn&#39;t let the noise disrupt or diminish her work to [deconstruct and attack the status quo](https://www.congress.gov/member/ayanna-pressley/P000617), on and off Capitol Hill.",
        "website": "https://pressley.house.gov/",
        "claimToFame": "Following her historic campaign, becoming the first black woman to represent Massachusetts in Congress, Pressley has been an outspoken opponent of the Trump administration&#39;s policies as a member of &quot;the Squad.&quot;",
        "influence": 185.5,
        "reach": 14.33,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/ayannapressley/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1UGkfSpD87tVZcHrPH7Sxz",
        "type": "Entry",
        "createdAt": "2019-09-17T19:49:32.812Z",
        "updatedAt": "2019-09-18T16:12:13.133Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 87,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/chaedria.labouvier.jpg",
        "name": "Chaédria LaBouvier",
        "job": "Journalist, activist, curator",
        "sector": "Arts",
        "twitterAccount": "chaedria",
        "location": "Dallas, New York City",
        "age": 34,
        "bio": "Chaédria LaBouvier turned her pain into passion. After her brother Clinton Allen was killed by a Dallas police officer in 2013, LaBouvier put her TV writing dreams on hold to advocate for justice. She then dove into researching one of her favorite artists, Jean-Michel Basquiat. After more than a decade of research, LaBouvier organized an exhibit centered on Basquiat&#39;s painting, &quot;Defacement (The Death of Michael Stewart),&quot; which was painted after a fellow artist was killed by police. Earlier this year, her exhibit, &quot;[Basquiat&#39;s &#39;Defacement&#39;: The Untold Story](https://www.guggenheim.org/exhibition/basquiats-defacement-the-untold-story),&quot; opened at New York City&#39;s [Guggenheim Museum](https://www.guggenheim.org/exhibition/basquiats-defacement-the-untold-story?gclid=CjwKCAjw5fzrBRASEiwAD2OSV_O8gxGD2_TiNW6k070g59Vg5UTOYTCMBNQ3E-Vc6wX2jZFx9Um40xoCf8MQAvD_BwE), making LaBouvier the first black woman [to organize a solo exhibit](https://www.nytimes.com/2019/07/30/arts/design/basquiat-defacement-guggenheim-curator.html) there.",
        "website": "https://mothersagainstpolicebrutality.org/",
        "claimToFame": "LaBouvier is the first black woman to organize a solo exhibit at New York City&#39;s Guggenheim Museum.",
        "influence": 137.4,
        "reach": 7.87,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/lalabouvier/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1hPfJMSo17RTKt8WU1D5GL",
        "type": "Entry",
        "createdAt": "2019-09-19T00:31:29.308Z",
        "updatedAt": "2019-09-24T23:09:38.030Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 91,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/jarrid.tingle.jpg",
        "name": "Jarrid Tingle",
        "job": "Venture capitalist and entrepreneur",
        "sector": "Business",
        "location": "New York City",
        "age": 27,
        "bio": "Jarrid Tingle is hungry. He graduated in the top 5 percent of his class at Harvard Business School this year and before that, he earned the highest academic honor for students at the Wharton School of the University of Pennsylvania. But diversity breeds diversity, and the [Forbes 30 under 30 honoree](https://www.forbes.com/profile/harlem-capital/?list=30under30-social-entrepreneurs#793741ff8837) discovered early that he wanted to [help more people who look like him](https://www.blackenterprise.com/meet-brothas-harlem-capital/) access opportunities he knew they weren&#39;t getting. Together with Henri Pierre-Jacques (also an honoree on this list), his friend and fellow Harvard Master of Business Administration, he conceptualized [Harlem Capital](http://harlem.capital/), a New York City-based venture capital firm that expects to [provide investment cash for 1,000 minority and woman-owned companies](https://www.theroot.com/meet-the-4-black-men-who-are-shaking-up-the-white-male-1836597048) who, until now, would probably be overlooked for funding. Raised by a single mother, it&#39;s Tingle&#39;s job as one-fourth of Harlem Capital&#39;s leadership to strategize deal sourcing and calculate the firm&#39;s risk so they can keep going strong.",
        "website": "http://harlem.capital/",
        "claimToFame": "Tingle is one-fourth of the dynamic Harlem Capital, a venture capital firm that provides startup funding for black, brown and woman-owned businesses.",
        "influence": 129.7,
        "reach": 5.93,
        "substance": 7.3
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5RjffS2dicR9J9Tkrc3iZ3",
        "type": "Entry",
        "createdAt": "2019-09-10T14:30:36.760Z",
        "updatedAt": "2019-09-13T16:34:21.903Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 10,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704266/The%20Root%20100%202019/karen.attiah.jpg",
        "name": "Karen Attiah",
        "job": "Global Opinions editor, the Washington Post",
        "sector": "Media",
        "twitterAccount": "KarenAttiah",
        "location": "Washington, D.C.",
        "age": 33,
        "bio": "The assassination of Saudi Arabian journalist and Washington Post columnist Jamal Khashoggi could&#39;ve been devoured by the frenetic news cycle of the Trump administration, but Attiah—the Global Opinions editor at the Post—used her journalistic brilliance and platform to keep his story at the fore. [Her reportage](https://www.washingtonpost.com/people/karen-attiah/) and outspokenness on Twitter garnered [international coverage](https://www.nytimes.com/2018/10/18/business/media/karen-attiah-jamal-kashoggi-editor-washington-post.html) and generated an ongoing conversation about rights, roles and protections for the free press. It&#39;s a reflection of the consistent and resonant work Attiah has produced throughout her career, covering race, gender and international politics with a focus on the global black community. This year, the Fulbright scholar [received an honorary doctorate](https://www.dickinson.edu/info/20309/commencement/3772/2019_commencement_citations) from Dickinson College for her contributions to journalism, and the National Association of Black Journalists honored her with its top recognition, the stellar Journalist of the Year Award, for turning her voice into a trumpet for people deprived of justice.",
        "website": "https://www.washingtonpost.com/people/karen-attiah/",
        "claimToFame": "As the Global Opinions editor at the Washington Post, Attiah has been an evangelist for racial equity and justice and became a champion for columnist Jamal Khashoggi, whose assassination exposed violence against the press.",
        "influence": 213.3,
        "reach": 11.68,
        "substance": 7.9,
        "instagramUrl": "https://www.instagram.com/karenattiah/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3hoIbaogJsX6tQ9tbmO7Hg",
        "type": "Entry",
        "createdAt": "2019-09-20T14:21:35.092Z",
        "updatedAt": "2019-09-24T22:55:16.894Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 74,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/jemele.hill.jpg",
        "name": "Jemele Hill",
        "job": "Journalist, podcast host",
        "sector": "Media",
        "twitterAccount": "jemelehill",
        "age": 43,
        "bio": "Jemele Hill is completely unbothered. After the then-ESPN commentator found herself in the middle of a controversy for calling Donald Trump [a white supremacist](https://www.theroot.com/5-things-that-will-happen-before-jemele-hill-apologizes-1814646398)—which, by the way, she happened to be right about—and making other political statements on Twitter, the journalist with a knack for clapping back at racist trolls left the sports network for [a gig](https://www.theatlantic.com/press-releases/archive/2018/10/jemele-hill-joining-atlantic-staff-writer/571798/) at The Atlantic, where she dishes spicy opinions like suggesting that black college athletes [leave predominantly white institutions](https://www.theatlantic.com/magazine/archive/2019/10/black-athletes-should-leave-white-colleges/596629/) to play for HBCUs. True to form, conservative trolls were quick [to label her &quot;pro-segregation](https://www.foxnews.com/entertainment/black-athletes-should-leave-white-colleges-jemele-hill-writes-in-controversial-op-ed).&quot; But she said what she said. This year, Hill partnered with Spotify to launch the podcast, _Jemele Hill is Unbothered_, where she sits down with some of our favorite celebs, writers, musicians and politicians to break down the hot topics of the day.",
        "claimToFame": "After leaving ESPN, the outspoken journalist took her talents to The Atlantic and Spotify, where she sits down with our favorite celebs and politicians to dish on her new podcast, _Jemele Hill is Unbothered._",
        "influence": 146.6,
        "reach": 12.03,
        "substance": 6.5,
        "instagramUrl": "https://www.instagram.com/jemelehill/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1RgrCGfUXwxJ2MA8VzGPGP",
        "type": "Entry",
        "createdAt": "2019-09-19T22:04:22.396Z",
        "updatedAt": "2019-09-23T19:52:12.348Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 29,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/virgil.abloh.jpg",
        "name": "Virgil Abloh",
        "job": "Artistic director, Louis Vuitton's menswear collection, CEO of Off-White",
        "sector": "Business",
        "twitterAccount": "virgilabloh",
        "location": "Chicago",
        "age": 38,
        "bio": "Over the past decade, Abloh has become one of the most sought after talents in fashion, working with celebs like Kanye West, Serena Williams and Michael B. Jordan. After becoming artistic director of Louis Vuitton&#39;s menswear collection in 2018, the Off-White founder quickly became one of the hardest working men in fashion. But the prolific designer and former architect got a chance to display his full range of talents in [his first museum exhibit](https://theglowup.theroot.com/figures-of-speech-with-his-1st-museum-exhibition-virg-1835357717) at Chicago&#39;s Museum of Contemporary Art this year. Part of that homecoming included the opening of the [NikeLab Chicago Re-Creation Center c/o Virgil Abloh](https://theglowup.theroot.com/homecoming-virgil-abloh-returns-to-chicago-with-nike-t-1835129981), specifically designed to inspire and empower the youth of Chicago. In addition to juggling his duties at Off-White and Louis Vutton, Abloh has partnerships with brands like [Moët &amp; Chandon](https://www.forbes.com/sites/karlaalindahao/2018/09/06/virgil-abloh-moet-chandon-limited-edition-champagne-bottles-2018/#1aa35f332882) and [Ikea](https://www.vogue.com/slideshow/virgil-abloh-and-off-white-home-collection), which is rolling out the designer&#39;s [MARKERAD collection this winter](https://www.housebeautiful.com/uk/decorate/a28830445/ikea-autumn-winter-trends/). In November, the award-winning designer&#39;s exhibit, &quot;Figures of Speech,&quot; will open at the [High Museum in Atlanta](https://high.org/exhibition/virgil-abloh-figures-of-speech/).",
        "website": "https://canary---yellow.com/",
        "claimToFame": "The prolific designer and artistic director of Louis Vuitton's menswear collection got a chance to display his full range of talents with his first museum exhibit at Chicago&#39;s Museum of Contemporary Art.",
        "influence": 184.6,
        "reach": 15.94,
        "substance": 6.8,
        "instagramUrl": "https://www.instagram.com/virgilabloh/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6VmwU2ImhizSqgTFx3DUY",
        "type": "Entry",
        "createdAt": "2019-09-17T22:26:24.243Z",
        "updatedAt": "2019-09-18T16:13:50.981Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 71,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/elie.mystal.jpg",
        "name": "Elie Mystal",
        "job": "Executive editor, Above the Law",
        "sector": "Media",
        "twitterAccount": "ElieNYC",
        "location": "New York City",
        "age": 41,
        "bio": "Elie Mystal has a lot to say about America&#39;s political climate, but thankfully he can back it up. The Harvard Law School graduate is the executive editor of the [Above the Law blog](https://abovethelaw.com/author/elie-mystal/), a [legal expert on WNYC&#39;s Supreme Court podcast](https://www.wnycstudios.org/people/elie-mystal), _More Perfect_, and he regularly appears on MSNBC as a legal analyst. While some legal experts can be a little monotonous, Mystal is known for his upbeat and thoroughly research-based style.",
        "website": "https://abovethelaw.com/",
        "claimToFame": "The in-demand legal expert is executive editor of Above the Law and an outspoken political analyst seen regularly on MSNBC.",
        "influence": 150,
        "reach": 9.38,
        "substance": 7.1
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5Q2L9iomfg4XLRf22kRVDy",
        "type": "Entry",
        "createdAt": "2019-09-17T19:28:51.221Z",
        "updatedAt": "2019-09-19T00:09:01.220Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 80,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/brittany.barnett.jpg",
        "name": "Brittany K. Barnett",
        "job": "Lawyer, co-founder of the Buried Alive Project",
        "sector": "Community",
        "twitterAccount": "msbkb",
        "location": "Dallas",
        "age": 35,
        "bio": "When Alice Marie Johnson was granted clemency by the Trump administration, [Kim Kardashian garnered all the headlines](https://www.theroot.com/celebrity-obsessed-trump-listens-to-kim-kardashian-com-1826608992), but Brittany K. Barnett was [one of the women Johnson had to thank](https://www.facebook.com/buriedaliveproject/photos/a.1447657482046200/1447657068712908/?type=3&amp; __xts__ %5B0%5D=68.ARCF29Rk4YSYRHgIAedcX1-LRtmRghb9Rq84YvL9bf-fq2VT7dY3JFjTLyWTroM_lqVLQsQbeS8xxh2OuZ31A89qvj8x17PgRPELcsT7vEYWD3xpySCAlNGDuwUrYh3qj-n-Nb4NzxTrPRNN7jMB5Y-mU7SMvasmjXvoqjcyDqu_cQuTbsZYIcM2D1j6zYTKljn5X6HxrkHVcrZ_hu84Au1J4VT6jUph3qyECFpdaTKToPDqcgmoAATEEAuWPBOj6eXJ7nsvXll3uF8wwtelzc2NakT4LHRHXaewgJQQDwfrWOcMl4nhZO6aeR58XnaZTsE6LlzGUKaR3aHKFOY4E8PKQTok&amp; __tn__ =-R). As the daughter of a formerly incarcerated woman, Barnett and her co-counsel MiAngel Cody (who is also an honoree on the list) have worked to help several people get their [drug-related life sentences commuted](https://www.brittanykbarnett.com/about). She and Cody launched the &quot;90 Days of Freedom&quot; campaign to secure the release of as many people as possible in that time period. Barnett is the co-founder of [the Buried Alive Project](https://www.brittanykbarnett.com/buried-alive-project), an organization that&#39;s advocating against life sentences for drug-related offenses.",
        "website": "https://www.brittanykbarnett.com/",
        "claimToFame": "A fierce advocate for her clients, Barnett was part of the legal team that successfully lobbied for clemency for Alice Marie Johnson.",
        "influence": 141,
        "reach": 8.29,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/msbkb"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "59cGI7DKEvUrZdQxPybHPz",
        "type": "Entry",
        "createdAt": "2019-09-17T18:58:53.827Z",
        "updatedAt": "2019-09-24T22:49:11.485Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 61,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/amanda.williams.jpg",
        "name": "Amanda Williams",
        "job": "Artist",
        "sector": "Arts",
        "location": "Chicago",
        "age": 45,
        "bio": "Amanda Williams’ art has something to say. Back in April, Williams and her friend and fellow artist Olalekan Jeyifous were picked to design a monument to Congresswoman Shirley Chisholm in Brooklyn, N.Y. In discussing the pair’s design, [the New York Times](https://www.nytimes.com/2019/04/23/arts/design/shirley-chisholm-monument-prospect-park.html) said that the monument will “re-evaluate what a public memorial can be.” The Chicago native has tackled issues of race, blackness and community in her work, which has been exhibited widely, including at the 2018 Venice Architecture Biennale and the Museum of Contemporary Art in Chicago. A graduate of Cornell University, Williams studied architecture before switching to visual arts. ",
        "website": "https://awstudioart.com/",
        "claimToFame": "The visual artist was chosen to be a  co-designer of a monument to Congresswoman Shirley Chisholm.",
        "influence": 158.4,
        "reach": 7.93,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/awstudioart/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5aEo5oiz3kksdcdb3VI0kQ",
        "type": "Entry",
        "createdAt": "2019-09-18T01:13:23.327Z",
        "updatedAt": "2019-09-24T00:06:46.099Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 17,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/tomi.adeyemi.jpg",
        "name": "Tomi Adeyemi",
        "job": "Author",
        "sector": "Arts",
        "twitterAccount": "tomi_adeyemi",
        "location": "San Diego, Calif.",
        "age": 26,
        "bio": "Move over George R.R. Martin, Tomi Adeyemi might just be the next big thing. The [Nigerian-American writer](http://www.tomiadeyemi.com/about) is the author of _Children of Blood and Bone_, a West African-inspired fantasy young-adult novel that was an international bestseller. The Harvard grad&#39;s book was such a hit, Hollywood came knocking. The film adaptation is being [developed by Lucasfilm](https://deadline.com/2019/08/children-of-blood-and-bone-movie-lucasfilm-kathy-kennedy-kay-oyegun-rick-famuyiwa-fox-disney-1202662804/) and will be the company&#39;s first project that isn&#39;t a _Star Wars_ or _Indiana Jones_ project.",
        "website": "http://www.tomiadeyemi.com/",
        "claimToFame": "The Nigerian-American writer is the author of _Children of Blood and Bone_, a West African-inspired fantasy young-adult novel that is being developed into a movie by Lucasfilm.",
        "influence": 202.3,
        "reach": 12.27,
        "substance": 7.6,
        "instagramUrl": "https://www.instagram.com/tomiadeyemi/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "349AoRLkLxaQhPCNto0HVk",
        "type": "Entry",
        "createdAt": "2019-09-17T23:20:26.520Z",
        "updatedAt": "2019-09-25T17:37:36.850Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 68,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/Joy.Buolamwini.jpg",
        "name": "Joy Buolamwini",
        "job": "Computer scientist",
        "sector": "STEM",
        "twitterAccount": "jovialjoy",
        "location": "Cambridge, Mass.",
        "age": 29,
        "bio": "She calls it the &quot;[Coded Gaze](https://www.youtube.com/watch?v=162VzSzzoPs).&quot; It&#39;s the implicit bias built into facial recognition software that glazes over darker skin tones. In artificial intelligence, as in real life, [black and brown people are erased or nonexistent](https://www.ted.com/talks/joy_buolamwini_how_i_m_fighting_bias_in_algorithms?language=en) and developers, who are mostly white, haven&#39;t done much to address it. But Buolamwini isn&#39;t having it. The experience of being unseen [inspired her thesis work at the Massachusetts Institute of Technology](https://www.technologyreview.com/lists/innovators-under-35/2018/pioneer/joy-buolamwini/). After she graduated, the Oxford University-trained tech leader founded the Algorithmic Justice League to call out bias in machine learning, particularly as its use increases in [predictive policing and justice system decision-making](https://www.nytimes.com/2019/05/15/business/facial-recognition-software-controversy.html) across the country. Her approach is collaborative, enlisting everyone with a vested interest in AI—coders, legislators, developers, citizens—to prevent white privilege from facilitating a new and dangerous threat to [the civil liberties and safety of melanated people](https://www.forbes.com/profile/joy-buolamwini/#3ce868a7358a).",
        "website": "http://www.ajlunited.org/",
        "claimToFame": "In the world of artificial intelligence, Buolamwini is working to reduce the built-in implicit bias in facial recognition software, which is critical as its use increases, particularly among law enforcement.",
        "influence": 153.4,
        "reach": 10.39,
        "substance": 6.9,
        "instagramUrl": "https://www.instagram.com/joyfulcode/?hl=ur"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "4KL5U94wqtHQ0OyV8jDqfx",
        "type": "Entry",
        "createdAt": "2019-09-19T11:39:57.410Z",
        "updatedAt": "2019-09-20T12:44:29.935Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 37,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/jason.reynolds2.jpg",
        "name": "Jason Reynolds",
        "job": "Author, poet",
        "sector": "Arts",
        "twitterAccount": "jasonreynolds83",
        "location": "Washington, D.C.",
        "age": 35,
        "bio": "As a writer, Jason Reynolds is prolific, churning out book after book, which is amazing when you consider that he was 17 years old before he [read an entire book from cover to cover](https://www.theguardian.com/books/2018/aug/04/jason-reynolds-murder-why-young-people-shun-reading-crochet). Less than 20 years later, he&#39;s made a mighty career of writing them for other young adults, particularly boys, who may not necessarily love to read yet. Fortunately, he&#39;s committed to never writing a boring book and so far, he&#39;s made good on that promise. In 2018, the New York Times-bestseller [won the prestigious Newbery Medal](http://www.ala.org/alsc/awardsgrants/bookmedia/newberymedal/newberyhonors/newberymedal/2018-newbery-medal-and-honor-books) for [_Long Way Down_](https://www.amazon.com/Long-Way-Down-Jason-Reynolds/dp/1481438255), a novel in verse inspired by his own story of grief and vengeance. He&#39;s currently working on a new book that reinterprets Ibram X. Kendi&#39;s award-winning _Stamped From the Beginning_ and makes [the conversation about racism](https://time.com/5650322/jason-reynolds-ibram-kendi-stamped-young-adult/) approachable for a young adult audience.",
        "website": "https://www.jasonwritesbooks.com/",
        "claimToFame": "Reynolds is an extraordinary author who examines real-life issues in a way that makes young black people—and not-so-young black people—want to read.",
        "influence": 178,
        "reach": 13.19,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/jasonreynolds83/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2r0jtZHJU3M8QtH1FgGVpm",
        "type": "Entry",
        "createdAt": "2019-09-17T18:55:08.600Z",
        "updatedAt": "2019-09-23T23:37:27.920Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 26,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704268/The%20Root%20100%202019/allyson.felix.jpg",
        "name": "Allyson Felix",
        "job": "Track athlete",
        "sector": "Sports",
        "twitterAccount": "allysonfelix",
        "location": "Los Angeles",
        "age": 33,
        "bio": "Allyson Felix is used to battling it out on the track, but after giving birth to her daughter, Camryn in 2018, she found herself a new opponent: the crisis in [black women&#39;s maternal health](https://theglowup.theroot.com/with-a-new-baby-sponsor-and-mission-olympian-allyson-1836872186). During her pregnancy, Felix suffered severe preeclampsia, which caused her to deliver her daughter prematurely at 32 weeks. While they both survived, after the harrowing incident, the Olympic athlete found her voice. Like her fellow U.S. track teammate, Alysia Montaño (who is also an honoree this year), Felix wrote [an op-ed](https://www.nytimes.com/2019/05/22/opinion/allyson-felix-pregnancy-nike.html) for the New York Times calling out Nike for attempting to pay her 70 percent less as a new mom. She ultimately parted ways with the sneaker company and went to become the first-ever sponsored athlete for Athleta, a women-focused sports brand.",
        "website": "https://www.allysonfelix.com/",
        "claimToFame": "The six-time Olympic gold medalist penned an op-ed calling out Nike for how the apparel firm dealt with athletes who became moms. Now she's the first-ever sponsored athlete for sports brand [Athleta](https://www.instagram.com/p/B0lkgVBgBsl/).",
        "influence": 188.3,
        "reach": 14.77,
        "substance": 7.3,
        "instagramUrl": "https://www.instagram.com/af85/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "45c9p3OSXnN4bN7vWxi9fh",
        "type": "Entry",
        "createdAt": "2019-09-18T01:16:43.963Z",
        "updatedAt": "2019-09-18T16:19:55.841Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 98,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704276/The%20Root%20100%202019/william.tarpeh.jpg",
        "name": "William Tarpeh",
        "job": "Assistant professor of chemical engineering, Stanford",
        "sector": "STEM",
        "twitterAccount": "tarpehdiem",
        "location": "Palo Alto, Calif.",
        "age": 28,
        "bio": "William Tarpeh is working on innovative ways to save the environment. An assistant professor of chemical engineering at Stanford University, Tarpeh is [experimenting with ways to reuse liquid waste](https://cheme.stanford.edu/people/william-tarpeh). Through the [Tarpeh Lab](https://tarpehgroup.stanford.edu/), the professor is reimagining ways waste recycling &quot;can lead to recovery of valuable products and more efficient, less costly approaches to reducing harmful discharges to the environment.&quot;",
        "website": "https://tarpehgroup.stanford.edu/",
        "claimToFame": "Tarpeh is working to find more effective and useful ways to reclaim and recycle liquid waste so that it has a more positive impact on the environment.",
        "influence": 115.5,
        "reach": 3.43,
        "substance": 7.9
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "1wptUqBjBNNf3e4PgcXonP",
        "type": "Entry",
        "createdAt": "2019-09-19T21:52:51.038Z",
        "updatedAt": "2019-09-23T23:09:42.673Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 4,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568650818/steven.canals_retouch_kigdmv.jpg",
        "name": "Steven Canals",
        "job": "Co-creator, executive producer of Pose",
        "sector": "Entertainment",
        "twitterAccount": "stevencanals",
        "location": "Los Angeles",
        "age": 38,
        "bio": "Steven Canals got the idea for _Pose_ [15 years ago](https://www.gq.com/story/steven-canals-profile) after watching the ballroom documentary _Paris Is Burning_ in college. Though he immediately wanted to bring similar stories to the screen, Canals wasn&#39;t sure he would be able to make it happen. Despite having a successful career in higher education, Canals took a chance and [moved to Los Angeles](https://twitter.com/StevenCanals/status/1169994874680045568) to pursue a Master of Fine Arts in screenwriting at UCLA, where he began working on _Pose_. After being turned down multiple times by several TV executives, Canals finally had the opportunity to pitch the idea to Ryan Murphy, who decided to help Canals bring it to TV.",
        "claimToFame": "Canals' award-winning drama, _Pose_, has offered some much needed visibility to the LGBTQ community and ballroom culture and we are here for it. ",
        "influence": 234.8,
        "reach": 10.08,
        "substance": 8.6,
        "instagramUrl": "https://www.instagram.com/svcanals/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "54YvTjMihMkiFaF7EO8jGY",
        "type": "Entry",
        "createdAt": "2019-09-18T01:08:50.597Z",
        "updatedAt": "2019-09-25T17:20:37.724Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 6,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 35,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1569430120/Rich.Paul_lzz0xu.jpg",
        "name": "Rich Paul",
        "job": "Sports agent",
        "sector": "Sports",
        "twitterAccount": "richpaul4",
        "location": "Los Angeles",
        "age": 37,
        "bio": "The NCAA tried it. When the organization put sports agents on notice that [new certification mandates](http://www.ncaa.org/enforcement/agents-and-amateurism/agent-certification) would require them to have a bachelor&#39;s degree and travel to headquarters for an in-person exam, Paul—who represents [a roster of NBA superstars](https://theundefeated.com/features/the-ncaa-doesnt-have-a-rich-paul-problem-it-has-a-problem-with-black-men/) including longtime friend LeBron James, Anthony Davis and Draymond Green—called them out on the ethical contradictions and racist foundations. He didn&#39;t finish his undergraduate education but has been extremely successful without it; in July, his firm, [Klutch Sports Group](https://www.forbes.com/companies/klutch-sports/#7b32e42879ad), one of the top athletic agencies in the country, [made a major deal](https://www.theroot.com/in-the-klutch-top-sports-agent-and-lebron-homie-rich-p-1836473280) with Hollywood&#39;s United Talent Agency, which named Paul head of UTA Sports, a new sports-focused arm of UTA. &quot;Requiring a four-year degree accomplishes only one thing—systematically excluding those who come from a world where college is unrealistic,&quot; Paul wrote in an op-ed. The blowback was so intense because of the new regulation—nicknamed the &quot;Rich Paul Rule&quot;—[the NCAA walked it back](https://www.espn.com/mens-college-basketball/story/_/id/27374124/ncaa-amends-rich-paul-rule-amid-blowback) not even a week later.",
        "website": "http://www.klutchgroup.com/",
        "claimToFame": "When the NCAA issued a discriminatory policy that affected black and less-privileged sports agents, Paul sparked the opposition that forced the organization to revoke the rule change.\n",
        "influence": 179.1,
        "reach": 13.36,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/richpaul/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "4pwN0k1fJDlnWdI1u0k2cG",
        "type": "Entry",
        "createdAt": "2019-09-18T00:36:26.724Z",
        "updatedAt": "2019-09-18T16:18:33.610Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 65,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/manu.platt.jpg",
        "name": "Manu Platt",
        "job": "Associate professor, Georgia Tech",
        "sector": "STEM",
        "twitterAccount": "DrPlattLab",
        "location": "Atlanta",
        "age": 40,
        "bio": "An associate professor and co-founder of [Project ENGAGES](https://projectengages.gatech.edu/) at Georgia Tech, Platt has been diversifying the study of engineering, cell biology and physiology for 10 years by facilitating opportunities for black and brown people in his eponymous lab. At the same time, he&#39;s continued his groundbreaking study of tissue remodeling in HIV, sickle cell and cardiovascular disease to address global health disparities. For his multifaceted work of researching biological solutions as he remedies systemic sociological issues, Platt was inducted into [the American Institute for Medical and Biological Engineering College of Fellows](https://news.emory.edu/stories/2019/03/aimbe_college_fellows/index.html), which comprises the top 2 percent of medical and biological engineers. The honor is the highest professional distinction awarded in the field of study and makes Platt—who is candid about his experience about a black man in science—one of the most accomplished individuals doing both the professional and systems-destroying labor.",
        "website": "https://bme.gatech.edu/bme/faculty/Manu-O-Platt",
        "claimToFame": "Platt was inducted into the prestigious American Institute for Medical and Biological Engineering College of Fellows for his 10 years of giving black and brown people opportunities in his Georgia Tech research lab.",
        "influence": 155.6,
        "reach": 5.91,
        "substance": 8
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "3IQw0Ua1GT5lzrEoE8Sj5V",
        "type": "Entry",
        "createdAt": "2019-09-17T19:12:24.625Z",
        "updatedAt": "2019-09-25T17:39:11.456Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 4,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 69,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704273/The%20Root%20100%202019/bassey.ikpi.jpg",
        "name": "Bassey Ikpi",
        "job": "Writer, author",
        "sector": "Media",
        "twitterAccount": "Basseyworld",
        "location": "Lanham, Md.",
        "age": 43,
        "bio": "Ikpi has made a career of telling the truth, most often her own. This year, the writer and former Def Poetry Jam performer released her essay collection, _I&#39;m Telling the Truth, But I&#39;m Lying_, about her life as a person with bipolar disorder. Within a week, it became a New York Times bestseller. The book begins in 2016, which she calls the worst year of her life, and takes readers through the swirling, honest, often exhausting experience of living with a mental health disorder. Ikpi is a longtime mental health advocate for people of color in particular and as the child of Nigerian parents, she&#39;s navigated the cultural stigmas that can distance folks in need from the help they should get. She founded #NoShameDay and [The Siwe Project](http://thesiweproject.org/) to center black folks in conversations about awareness.",
        "website": "http://basseyikpi.com/",
        "claimToFame": "Her essay collection and New York Times bestseller, _I&#39;m Telling the Truth, But I&#39;m Lying_, centers the experiences of a black woman with bipolar disorder and broadens the conversation about mental health in our culture.",
        "influence": 150.7,
        "reach": 9.45,
        "substance": 7,
        "instagramUrl": "https://www.instagram.com/basseyworld/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "5jLMJbDVeMy15WcUcuC8To",
        "type": "Entry",
        "createdAt": "2019-09-17T19:59:46.479Z",
        "updatedAt": "2019-09-25T17:17:28.011Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 6,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704274/The%20Root%20100%202019/colin.kaepernick.jpg",
        "name": "Colin Kaepernick",
        "job": "Activist",
        "sector": "Community",
        "twitterAccount": "kaepernick7",
        "age": 31,
        "bio": "Since taking a knee to protest racism and police brutality in 2016, the former NFL star has been unable to do what he loves: play football. Instead, Colin Kaepernick has continued to advocate for others, donating more than $1 million to community groups while founding his own nonprofit, the [Know Your Rights Camp](https://www.knowyourrightscamp.com/). After filing a collusion grievance against the NFL in 2017, Kaepernick and former teammate Eric Reed [settled with the league](https://www.nytimes.com/2019/03/21/sports/colin-kaepernick-nfl-settlement.html) earlier this year. Despite being shut out of sports, support for Kaepernick continues. When he asked Nike to pull its limited edition Betsy Ross flag sneakers due to its racist iconography, the company agreed—sparking both outrage and praise. It also helped [Nike&#39;s market value go up by $3 billion](https://www.theroot.com/imwithkap-nike-s-market-value-jumps-3-billion-after-1836307099). And when Jay-Z and NFL inked a partnership deal, all anyone could talk about was Kaepernick and how the move was [an affront to Kaepernick&#39;s cause](https://www.theguardian.com/music/2019/sep/06/jay-z-nfl-concert-kaepernick-backlash).",
        "website": "https://kaepernick7.com/",
        "claimToFame": "The former NFL quarterback and activist may still not have a job, but his presence and influence still resonates on and off the playing field.",
        "influence": 224.8,
        "reach": 16.85,
        "substance": 7.4,
        "instagramUrl": "https://www.instagram.com/kaepernick7/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "4GblndxTVb1OJFWCLxW1eY",
        "type": "Entry",
        "createdAt": "2019-09-17T19:45:29.584Z",
        "updatedAt": "2019-09-18T16:11:57.503Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 45,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1568650818/cardi.b_retouch_cylswc.jpg",
        "name": "Cardi B",
        "job": "Rapper",
        "sector": "Entertainment",
        "twitterAccount": "iamcardib",
        "location": "New York, Atlanta",
        "age": 26,
        "bio": "Belcalis Almanzar, known to the world as Cardi B, is a real one. She solidified her bona fides when she made history as [the first female rapper to have two No. 1 hits](https://www.billboard.com/articles/columns/chart-beat/8463605/cardi-b-i-like-it-hot-100-number-one-j-balvin-bad-bunny) from a debut album on [the Billboard Hot 100](https://www.bet.com/music/2018/01/02/cardi-b-tied-with-the-beatles-in-making-billboard-history.html). And now she&#39;s expanding her brand beyond music—early in the political season, [she chopped it up](https://time.com/5548908/cardi-b-politics/) with Democratic presidential candidate and Sen. Bernie Sanders (I-Vt.) and had a scene-stealing role in the box-office smash, _Hustlers_, starring fellow Bronx native Jennifer Lopez. As for her day job, Cardi B led all comers for the 2019 BET Hip Hop Awards with 10 nominations and her hit album, _Invasion of Privacy_, won the [Best Rap Album Grammy](https://www.youtube.com/watch?v=rdoTCg1Ewxk) in February. While she may have [lost her bid](https://theglowup.theroot.com/access-denied-okurrr-cardi-b-turned-down-for-a-tradem-1836041564) to trademark her signature &quot;Okurrr!,&quot; everything is A-OK for Cardi B.",
        "website": "https://www.cardibofficial.com/",
        "claimToFame": "Having solidified her star power as a rap artist, the superstar is expanding her range, juggling motherhood, political commentary and even a movie role.",
        "influence": 170.6,
        "reach": 18.48,
        "substance": 6.3,
        "instagramUrl": "https://www.instagram.com/iamcardib/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "6cqUQZPf2eghrhg0Mrr71p",
        "type": "Entry",
        "createdAt": "2019-09-17T19:16:11.370Z",
        "updatedAt": "2019-09-23T23:33:47.595Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 3,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 23,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704270/The%20Root%20100%202019/blair.imani.jpg",
        "name": "Blair Imani",
        "job": "Activist",
        "sector": "Community",
        "twitterAccount": "blairimani",
        "location": "New York City",
        "age": 25,
        "bio": "Being Muslim in America can be tough. Being a black, queer, Muslim woman who wears a hijab can sometimes make you a target. But writer and activist [Blair Imani](https://jezebel.com/a-conversation-with-activist-blair-imani-about-her-femi-1830339794) isn&#39;t afraid to celebrate all of her identities at once, no matter who objects. Imani is the author of [_Modern HERstory_](http://blairimani.com/books/)_: Stories of Women and Nonbinary People Rewriting History_ and the forthcoming, [_Making Our Way Home_](https://www.penguinrandomhouse.com/books/608103/making-our-way-home-by-blair-imani-foreword-by-patrisse-cullors/9781984856920/)_: The Great Migration and The Black American Dream_. Imani is also [an official ambassador](https://static1.squarespace.com/static/55120ecae4b01593abadc441/t/5c3e73ee03ce646dc646df0c/1547596782714/12749199-activist-and-author-blair-imani-joins-muslims-for-progressive-values-as-an-official-ambassador.pdf) for Muslims for Progressive Values, one of the oldest Muslim organizations to support the LGBTQ community.",
        "claimToFame": "A writer, activist and historian, Imani is a fierce advocate for the black, LGBTQ and Muslim communities.",
        "influence": 191.4,
        "reach": 11.57,
        "substance": 7.5,
        "instagramUrl": "https://www.instagram.com/blairimani/?hl=en"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "kid9docxrk2o"
          }
        },
        "id": "2vpCv8Hptf9fonZf6PCP9j",
        "type": "Entry",
        "createdAt": "2019-09-19T00:27:16.847Z",
        "updatedAt": "2019-09-20T12:45:00.138Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "entry"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "rank": 72,
        "imageUrl": "https://gawker-media-ressh.cloudinary.com/image/upload/v1567704267/The%20Root%20100%202019/henri.pierre.jacques.jpg",
        "name": "Henri Pierre-Jacques",
        "job": "Managing partner, Harlem Capital",
        "sector": "Business",
        "twitterAccount": "hpierrejacques",
        "location": " New York City",
        "age": 26,
        "bio": "When Pierre-Jacques graduated with honors from Harvard Business School with a Master of Business Administration in hand, he already had a plan in motion to put it to exceptional use. Along with his classmate and friend Jarrid Tingle (who is also an honoree on this list)—who was also his co-worker at ICV Partners, one of only a few black-owned private equity firms in the country—[the Haitian-American, Forbes 30 under 30 honoree](https://www.forbes.com/profile/harlem-capital/?list=30under30-social-entrepreneurs#793741ff8837) had conceptualized [Harlem Capital](http://harlem.capital/), a New York City-based venture capital firm. They paired up with venture partners Brandon Bryant, an investment banking analyst, and John Henry (both also honorees), a successful entrepreneur and real estate tech investor. Pierre-Jacques is a master networker who specializes in fund strategy, partnerships and financial analysis, and [together their vision for Harlem Capital crystalized](https://www.theroot.com/meet-the-4-black-men-who-are-shaking-up-the-white-male-1836597048) into investment cash for minority and women-owned companies that are chronically overlooked by traditional funders. Four highly educated black men in their 20s [funneling early-stage funding into businesses](https://www.forbes.com/sites/antoinegara/2019/06/24/harlem-capital-tpg-capital-jarrid-tingle-henri-pierre-jacques/#5a328f3e52c2) owned by women and people of color? Come through, Harlem Capital. Come on through.",
        "website": "http://harlem.capital/",
        "claimToFame": "Pierre-Jacques is one-fourth of the dynamic Harlem Capital, a venture capital firm that provides startup funding for black, brown and women-owned businesses.",
        "influence": 148.2,
        "reach": 7.74,
        "substance": 7.3
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/data/data.js